import React, { useState, useEffect } from "react";
import Select1 from "react-select";
import PersonalInfo from "./Personalinfo";
import ReactPhoneInput from "react-phone-input-2";
import { DatePickerInput, DatePicker } from "rc-datepicker";
import moment from 'moment';
// import Cross from "../../../Assets/Img/Group 208.png";
import "rc-datepicker/lib/style.css";
import RequiredFeild from "../../Atoms/RequiredFeild";
import { NavLink, useNavigate } from "react-router-dom";
import PostData from "../../../Api/PostData";
import countries from '../../../Assets/Data/countries.json'
import cities from '../../../Assets/Data/cities.json'
import countriesStateCities from '../../../Assets/Data/countries_states_cities.json'
import Swal from 'sweetalert2'
import './style.css'
import axios from "axios";
import Icon from '@ant-design/icons';
import GetData from "../../../Api/GetData";
import { Upload, message } from 'antd';
import { Select, Form, Tooltip, Button, Divider } from 'antd';
import analytics from '../../../firebase.config'
import { getAnalytics, logEvent } from "firebase/analytics";
import Compress from "react-image-file-resizer";
import Disclaimer from "../../Atoms/Disclaimer";
const { Option, OptGroup, } = Select;

const PersonalDetails = ({
  handleDrctChange,
  prevStep,
  nextStep,
  handleChange,
  values,
}) => {
  const [sendingSaveReq, setsendingSaveReq] = useState(false);
  const [residentialCity, setResidentialCity] = useState([]);
  const [selectedResidentialProvince, setSelectedResidentialProvince] = useState([]);
  const [imageUrl, setimageUrl] = useState([]);
  const [backAndContinueBtnStatus, setBackAndContinueBtnStatus] = useState(false);

  const [selectedmailProvince, setSelectedMailProvince] = useState([]);
  const [mailCity, setMailCity] = useState([]);
  const [errorMessage, setErrorMessage] = useState(false);
  const [error, setError] = useState(false);
  // const [addnominee, setAddNominee] = useState(false);
  function getSecondPart(str) {
    if (str) {
      return str.split("/")[1];
    }
    else {
      return "pdf"
    }
  }

  var ProofRelationFileName1;
  var PermanentProofRelationFileparam;
  var MailingProofRelationFileparam;
  var ProofRelationFileUnCompressedvar;
  var remitanceValue;
  var remitanceName;
  useEffect(() => {
    // 

    if (values?.country && values?.residentiaProvinceList == []) {
      hanldeResendentialCountries(values?.country)
    }

    // getFileData()
  }, [])
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const getFileData = () => {


    const response = GetData.getSavedFileData(values?.ProofRelationFileName);
    response.then((value) => {


      let imageUrlbase64 = 'data:image/jpeg;base64,' + value?.data
      setimageUrl(imageUrlbase64)
    })
  }

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader?.readAsDataURL(img);
  }
  const onFileResize = (e) => {

    const file = e.target.files[0];
    Compress.imageFileResizer(
      file, // the file from input
      1200, // width
      700, // height
      "JPEG", // compress format WEBP, JPEG, PNG
      50, // quality
      0, // rotation
      (uri) => {
        let responseUrl = [uri]
        handleDrctChange("ProofRelationFile", responseUrl)

      },
      "file" // blob or base64 default base64
    );
  }
  function beforeUpload(file) {
    // const isJPG = file.type === 'image/jpeg';
    // if (!isJPG) {
    //   message.error('You can only upload JPG file!');
    // }
    const isLt2M = file.size / 1024 / 1024 < 2;
    // if (!isLt2M) {
    //   message.error('Image must smaller than 2MB!');
    // }
    return isLt2M;
  }

  const handleChange1 = (info) => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      handleDrctChange("ProofRelationFile", info.file.originFileObj)

      getBase64(info.file.originFileObj, imageUrl => setimageUrl(imageUrl));
    }
  }
  const history = useNavigate();



  var signedEmail = JSON.parse(localStorage.getItem("user")).email;

  var moveToOtpScreenOtpRejected = localStorage.getItem("editFormStatusForReturnOnOtp")
  var editFormStatus = localStorage.getItem("editFormStatus");



  const onChangeDate = (event, name, minDate, maxDate) => {


    let dateConvert = convert(event);

    handleDrctChange(name, dateConvert);
  };
  const convert = (str) => {
    var date = new Date(str),


      mnth = date.toLocaleString("default", { month: "short" }),
      day = ("0" + date.getDate()).slice(-2);

    return [day, mnth, date.getFullYear()].join("-");
  };

  const Type = [
    { value: "NKA", label: "Normal Account" },
    { value: "SKA", label: "Sahulat Account" },
  ];
  const Realtions = [
    { value: "F", label: "Father's Name" },
    { value: "H", label: "Husband's Name" },
  ];
  const Residents = [
    { value: "01", label: "Resident" },
    { value: "02", label: "Non-Resident" },
  ];
  const City = [
    { value: "Lahore", label: "Lahore" },
    { value: "Karachi", label: "Karachi" },
    { value: "Multan", label: "Multan" },
    { value: "Rawalpindi", label: "Rawalpindi" },
    { value: "Islamabad", label: "Islamabad" },
    { value: "Quetta", label: "Quetta" },
  ];

  const Provinces = [
    { value: "01", label: "Fata / Fana", Province_code: '01' },
    { value: "02", label: "Sindh", Province_code: '02' },
    { value: "03", label: "Punjab", Province_code: '03' },
    { value: "04", label: "Khyber Pakhtunkhwa", Province_code: '04' },
    { value: "05", label: "Balochistan", Province_code: '05' },
    { value: "06", label: "Fedral Capital", Province_code: '06' },
    { value: "07", label: "Azad And Jamu Kashmir", Province_code: '07' },
  ];
  const RealitiveRelation = [
    // { value: "01", label: "Self" },
    { value: "2", label: "Father" },
    { value: "3", label: "Mother" },
    { value: "4", label: "Son" },
    { value: "5", label: "Daughter" },

    { value: "7", label: "Company" },
    { value: "6", label: "Husband" },
    // { value: "06", label: "Husband" },
  ];
  const NomineeRelations = [
    { value: "1", label: "Spouse" },
    { value: "2", label: "Father" },
    { value: "3", label: "Mother" },
    { value: "4", label: "Brother" },
    { value: "5", label: "Sister" },
    { value: "6", label: "Daughter" },
    { value: "7", label: "Son" },

  ];
  const Salutations = [
    { value: "MR", label: "Mr." },
    { value: "MRS", label: "Mrs." },
    { value: "MS", label: "Ms." },
    // { value: "04", label: "Others" },

  ]
  const PermanentProofOfAddressType = [
    { value: "Utility Bill", label: "Utility Bill" },
    { value: "Bank Statement", label: "Bank Statement" },
    { value: "Rental Agreement", label: "Rental Agreement" },
    { value: "Tax Return", label: "Tax Return" },
    { value: "House Purchase Agreement", label: "House Purchase Agreement" },
  ];
  const MailingProofOfAddressType = [
    { value: "Utility Bill", label: "Utility Bill" },
    { value: "Bank Statement", label: "Bank Statement" },
    { value: "Rental Agreement", label: "Rental Agreement" },
    { value: "Tax Return", label: "Tax Return" },
    { value: "House Purchase Agreement", label: "House Purchase Agreement" },
  ];



  const NomineeIDType = [
    { value: "CNIC", label: "CNIC (country of stay is Pakistan)" },
    { value: "NICOP", label: "NICOP (country of stay is another country)" },
    { value: "SNIC", label: "SNIC (with chip & country of stay is Pakistan)" },
    { value: "POC", label: "POC (Pakistan Origin Card)" },

  ];


  const openSaveExitModel = () => {


    Swal.fire({
      title: 'You’re almost there!',
      text: "Are you sure you want to exit the account opening form? It only takes a couple of minutes to finish.",
      icon: 'success',
      showCancelButton: true,
      confirmButtonColor: '#e5386a',
      // cancelButtonColor: '#d33',
      cancelButtonText: "Continue",
      // showDenyButton: true,
      // showCancelButton: true,
      confirmButtonText: 'Exit',
      // denyButtonText: `Don't save`,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    }).then((result) => {

      if (result.isConfirmed == true) {

        if (moveToOtpScreenOtpRejected == 'true' || editFormStatus == 'true') {
          history("/Otp");


        }
        else {
          history("/");
        }

      }



    })
    // // Get the modal
    // var modal = document.getElementById("SaveExitModal");

    // // Get the <span> element that closes the modal
    // var span = document.getElementsByClassName("close");
    // // When the user clicks the button, open the modal
    // modal.style.display = "block";

    // // When the user clicks on <span> (x) or Close, close the modal

    // for (let i = 0; i < span.length; i++) {

    //   span[i].onclick = function () {

    //     modal.style.display = "none";
    //   };
    // }
    // // When the user clicks anywhere outside of the modal, close it
    // window.onclick = function (event) {

    //   if (event.target == modal) {
    //     // localStorage.clear();
    //     // history("/");
    //     logout()
    //     modal.style.display = "none";

    //   }
    // };
  };

  const logout = () => {

    localStorage.clear();
    history("/");
    // modal.style.display = "none";
  }
  const SaveSubmit = () => {
    logEvent(analytics, 'aof_pers_info_press_save_and_exit');

    if (values?.Citizenship?.children == "Pakistan" && values?.Resident?.children == 'Resident') {
      remitanceValue = "7";
      remitanceName = 'Resident Pakistani'
    }
    else if (values?.Citizenship?.children == "Pakistan" && values?.Resident?.children != 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "1"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "2"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }
    else if (values?.Citizenship?.children != "Pakistan" && values?.Resident?.children == 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "3"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "4"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }
    else if (values?.Citizenship?.children != "Pakistan" && values?.Resident?.children != 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "5"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "6"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }
    // logEvent(analytics, 'labelaof',{name:'rizwan.qadeer@u2ventures.io'});

    setsendingSaveReq(true)



    // if (values.ProofRelationFile) {

    //   let fileData = [
    //     values.ProofRelationFile,

    //   ]

    //   let fileResponse
    //   fileData.forEach((element, index) => {

    //     fileResponse = PostData.FileAndImageUpload(element, setError, true);
    //     fileResponse.then((value) => {


    //       ProofRelationFileName1 = value?.data?.fileName
    //       handleDrctChange("ProofRelationFileName", ProofRelationFileName1)
    //       submitForm()
    //     })
    //   })
    // }

    if (values.ProofRelationFile || values.PermanentProofRelationFile || values?.MailingProofRelationFile) {

      let fileData = [
        values.ProofRelationFile,
        values?.PermanentProofRelationFile,
        values?.MailingProofRelationFile,
        values?.ProofRelationFileUnCompressed

      ]

      let fileResponse

      let counter = 0

      fileData.forEach((element, index) => {
        fileResponse = PostData.FileAndImageUpload(element, setError, true);
        fileResponse.then((value) => {
          console.log('save file is=========>>', value)

          let promise = new Promise((resolve, reject) => {


            if (index == 0) {
              ProofRelationFileName1 = value?.data?.fileName
              counter += 1;
            }
            else if (index == 1) {
              PermanentProofRelationFileparam = value?.data?.fileName
              counter += 1;

            }
            else if (index == 2) {
              MailingProofRelationFileparam = value?.data?.fileName
              counter += 1;
            }
            else if (index == 3) {
              ProofRelationFileUnCompressedvar = value?.data?.fileName
              counter += 1;

            }
            // else if (index == 4) {
            //   CNICFileUnCompressesFrontNamevar = value?.data?.fileName
            //   counter += 1;

            // }
            // else if (index == 5) {
            //   CNICFileUnCompressedBackNamevar = value?.data?.fileName
            //   counter += 1;

            // }

            if (counter == 4) {
              resolve('success')
            }
          })
          promise.then(data => {
            if (data) {
              submitForm()
            }
          })


        })

      })


    }
    else {
      submitForm()
    }
  };
  const handleBackBtn = () => {
    logEvent(analytics, 'aof_pers_info_press_back');
    handleDrctChange('step', 1)
  }


  const SaveOnContinueSubmit = (e) => {
    e?.preventDefault();
    setBackAndContinueBtnStatus(true)
    logEvent(analytics, 'aof_pers_info_press_continue');
    if (values?.Citizenship?.children == "Pakistan" && values?.Resident?.children == 'Resident') {
      remitanceValue = "7";
      remitanceName = 'Resident Pakistani'
    }
    else if (values?.Citizenship?.children == "Pakistan" && values?.Resident?.children != 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "1"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "2"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }
    else if (values?.Citizenship?.children != "Pakistan" && values?.Resident?.children == 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "3"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "4"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }
    else if (values?.Citizenship?.children != "Pakistan" && values?.Resident?.children != 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "5"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "6"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }

    // new upload work 

    // if (values.ProofRelationFile || values.PermanentProofRelationFile || values?.MailingProofRelationFile) {
    //   let fileData = []
    //   values.ProofRelationFileNewUpload && fileData.push(values.ProofRelationFile)
    //   values.PermanentProofRelationFileNewUpload && fileData.push(values.PermanentProofRelationFile)
    //   values.MailingProofRelationFileNewUpload && fileData.push(values.MailingProofRelationFile)


    //   let fileResponse

    //   let counter = 0
    //   console.log(fileData.length, 'newarray =============', fileData)

    //   fileData.forEach((element, index) => {
    //     console.log('save file is=========>>element =', element)
    //     fileResponse = PostData.FileAndImageUpload(element, setError, true);
    //     fileResponse.then((value) => {
    //       console.log('save file is=========>>', value)

    //       let promise = new Promise((resolve, reject) => {


    //         if (index == 0) {
    //           ProofRelationFileName1 = value?.data?.fileName
    //           counter += 1;
    //         }
    //         else if (index == 1) {
    //           PermanentProofRelationFileparam = value?.data?.fileName
    //           counter += 1;

    //         }
    //         else if (index == 2) {
    //           MailingProofRelationFileparam = value?.data?.fileName
    //           counter += 1;
    //         }


    //         if (counter == fileData.length) {
    //           console.log(counter, 'yes ========', fileData.length)
    //           resolve('success')
    //         }
    //       })
    //       promise.then(data => {
    //         console.log('data ========', data)

    //         if (data) {
    //           console.log('ProofRelationFileName1 ========', ProofRelationFileName1)
    //           console.log('PermanentProofRelationFileparam ========', PermanentProofRelationFileparam)
    //           console.log('MailingProofRelationFileparam ========', MailingProofRelationFileparam)
    //           submitFormOncontinue()
    //         }
    //       })


    //     })

    //   })


    // }





    if (values.ProofRelationFile || values.PermanentProofRelationFile || values?.MailingProofRelationFile) {

      let fileData = [
        values.ProofRelationFile,
        values?.PermanentProofRelationFile,
        values?.MailingProofRelationFile,
        values?.ProofRelationFileUnCompressed

      ]

      let fileResponse

      let counter = 0

      fileData.forEach((element, index) => {
        fileResponse = PostData.FileAndImageUpload(element, setError, true);
        fileResponse.then((value) => {
          console.log('save file is=========>>', value)

          let promise = new Promise((resolve, reject) => {


            if (index == 0) {
              ProofRelationFileName1 = value?.data?.fileName
              counter += 1;
            }
            else if (index == 1) {
              PermanentProofRelationFileparam = value?.data?.fileName
              counter += 1;

            }
            else if (index == 2) {
              MailingProofRelationFileparam = value?.data?.fileName
              counter += 1;
            }
            else if (index == 3) {
              ProofRelationFileUnCompressedvar = value?.data?.fileName
              counter += 1;

            }
            // else if (index == 4) {
            //   CNICFileUnCompressesFrontNamevar = value?.data?.fileName
            //   counter += 1;

            // }
            // else if (index == 5) {
            //   CNICFileUnCompressedBackNamevar = value?.data?.fileName
            //   counter += 1;

            // }

            if (counter == 4) {
              resolve('success')
            }
          })
          promise.then(data => {
            if (data) {
              submitFormOncontinue()
            }
          })


        })

      })


    }


    else {
      submitFormOncontinue()
    }

  }

  const submitFormOncontinue = () => {


    localStorage.setItem("save&exist", "true");
    console.log(values?.PermanentProofOfAddressCheckbox, 'PermanentProofRelationFileparam are ==========>>', PermanentProofRelationFileparam)


    let params = {
      uid: JSON.parse(localStorage.getItem("user"))?.user_id,
      status: false, // status true for submition and false for save and exist
      RelationUS: values?.USResident,
      NonRelationUSPAK: values?.TaxPayer,
      RelationOrganization: values?.AssoiciatedEmployee,
      EarnIncome: values?.EarnIncome,
      // below section for Personal  Detail
      ACCOUNT_TYPE: values?.Type?.value,
      ACCOUNT_TYPE_KEY: values?.Type?.children,
      //ACCOUNT_TYPE: 'NKA',
      //ACCOUNT_TYPE_KEY: 'Normal Account',
      SALUTATION: values?.Salutations.value,
      SALUTATION_KEY: values?.Salutations?.children?.toUpperCase(),

      firstName: values?.firstName,
      lastName: values?.lastName,
      PLACE_OF_BIRTH: values?.placeOfBirth,
      GENDER: values?.Gender,
      MARITAL_STATUS: values?.MaritalStatus,
      RELATIONSHIP1: values?.Relation?.value,
      RELATIONSHIP1_KEY: values?.Relation?.children,

      FATHER_HUSBAND_NAME: values?.RelativeName,
      DATE_OF_BIRTH: values?.BirthDay,
      NATIONALITY: values?.Citizenship?.value,
      NATIONALITY_KEY: values?.Citizenship?.children,
      residentialStatus: values?.IDType == 'NICOP' || values?.IDType == 'POC' ? "02" : "01",
      RESIDENT_KEY: values?.IDType == 'NICOP' || values?.IDType == 'POC' ? "Non-Resident" : "Resident",
      // Residential Adddrss feilds start
      PERMANENT_ADDRESS_1: values?.Apt,
      PERMANENT_ADDRESS_2: values?.street,

      // PERMANENT_ADDRESS_3: values?.PermannentAddressLine3 ? values?.PermannentAddressLine3 : values?.country?.iso3,
      // MAILING_ADDRESS_3: values?.MailingAddressLine3 ? values?.MailingAddressLine3 : values?.mailCountry?.label ? values?.mailCountry?.label : values?.mailCountry?.iso3,

      // PERMANENT_ADDRESS_3: values?.PermannentAddressLine3 ? values?.PermannentAddressLine3 : values?.country?.label,
      // MAILING_ADDRESS_3: values?.MailingAddressLine3 ? values?.MailingAddressLine3 : values?.country?.label ? values?.country?.label : values?.country?.iso3 || values?.country?.iso2,
      PERMANENT_ADDRESS_3: values?.PermannentAddressLine3 ? values?.PermannentAddressLine3 : values?.country?.label,
      MAILING_ADDRESS_3: values?.MailingAddressLine3 ? values?.MailingAddressLine3 : values?.mailCountry?.label ? values?.mailCountry?.label : values?.mailCountry?.iso3 || values?.mailCountry?.iso2,
      // MAILING_ADDRESS_3: values?.MailingAddressLine3 ? values?.MailingAddressLine3 : values?.mailCountry?.label ? values?.mailCountry?.label : values?.mailCountry?.iso3 || values?.mailCountry?.iso2,

      // Xb: obj ,


      PROOF_OF_ADDRESS: values?.PermanentProofOfAddressCheckbox == false ? (values.PermanentProofRelationFileName ? values.PermanentProofRelationFileName : PermanentProofRelationFileparam ? PermanentProofRelationFileparam : '') : '',
      PROOF_OF_ADDRESS_TYPE: values?.PermanentProofOfAddressCheckbox == false ? (values?.permanentProofOfAddressType?.children ? values?.permanentProofOfAddressType?.children : "") : '',

      // Residential Adddrss feilds start

      // Mailing Adddrss feilds start
      Xd: values?.MailingAddress == false ? "true" : "false",
      MAILING_ADDRESS_2: values?.MailingAddress == false ? values?.Mailstreet : values?.street,
      MAILING_ADDRESS_1: values?.MailingAddress == false ? values?.MailApt : values?.Apt,






      COUNTRY: values?.MailingAddress == false ?
        (values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan') ?
          values?.mailCountry?.iso3 : values?.mailCountry?.iso2
        : (values?.country?.children == 'Pakistan' || values?.country?.label == 'Pakistan') ? values?.country?.iso3 : values?.country?.iso2,




      COUNTRY_KEY: values?.mailCountry?.label || values?.mailCountry?.label ? values?.mailCountry?.label : values?.mailCountry?.iso3,



      CITY_TOWN_VILLAGE: values?.MailingAddress == false ?
        (values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan') ? values?.MailCity?.City_Code || values?.MailCity?.label : '' :

        (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? values?.City?.City_Code || values?.City?.label : '',





      CITY_TOWN_VILLAGE_KEY: values?.MailingAddress == false ? values?.MailCity?.label : values?.City?.label,


      PROVINCE_STATE: values?.MailingAddress == false ?

        ((values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan')
          ? values?.MailProvinces?.Province_code || values?.MailProvinces?.state_code : '')


        : (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? values?.Provinces?.Province_code || values?.Provinces?.state_code : '',

      PROVINCE_STATE_KEY: values?.MailingAddress == false ? values?.MailProvinces?.label : values?.Provinces?.label,
      OTHERPROVINCE_STATE: values?.MailingAddress == false ? (values?.mailCountry?.label != 'Pakistan' && values?.mailCountry?.children != 'Pakistan') ? values?.MailProvinces?.label : "" : (values?.country?.label != 'Pakistan' && values?.country?.children != 'Pakistan') ? values?.Provinces?.Province_code || values?.Provinces?.state_code : '',
      OTHERCITY_TOWN_VILLAGE: values?.MailingAddress == false ?
        ((values?.mailCountry?.label != 'Pakistan' && values?.mailCountry?.children != 'Pakistan') ? values?.MailCity?.label : "") :

        (values?.country?.label != 'Pakistan' && values?.country?.children != 'Pakistan') ? values?.City?.City_Code || values?.City?.label : '',





      // permanent country list

      PERMANENT_COUNTRY: (values?.country?.children == 'Pakistan' || values?.country?.label == 'Pakistan') ? values?.country?.iso3 : values?.country?.iso2 || values?.country?.iso3,
      COUNTRY1_KEY: values?.country?.label || values?.country?.children,
      PERMANENT_PROVINCE: (values?.country?.children !== 'Pakistan' && values?.country?.label !== 'Pakistan') ? '' : values?.Provinces?.Province_code || values?.Provinces?.state_code,
      PROVINCE_KEY: values?.Provinces?.label,
      PERMANENT_CITY_TOWN: (values?.country?.children !== 'Pakistan' && values?.country?.label !== 'Pakistan') ? '' : values?.City?.City_Code || values?.City?.label,
      PERMANENT_CITY_TOWN_VILLAGE_KEY: values?.City?.label,

      PERMANENT_OTHERPROVINCE: (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? "" : values?.Provinces?.Province_code || values?.Provinces?.state_code,
      PERMANENT_OTHERCITY_TOWN: (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? "" : values?.City?.City_Code ? values?.City?.City_Code : values?.City?.label,
      EMPLOYER_ADDRESS: values?.EmployStreet ? values?.EmployStreet : "",








      PROOF_OF_ADDRESS_MAILING: values?.MailingProofOfAddressCheckbox == false ? (values.MailingProofRelationFileName ? values.MailingProofRelationFileName : MailingProofRelationFileparam ? MailingProofRelationFileparam : '') : '',
      PROOF_OF_ADDRESS_MAILING_TYPE: values?.MailingProofOfAddressCheckbox == false ? (values?.mailingProofOfAddressType?.children ? values?.mailingProofOfAddressType?.children : "") : '',




      // Mailing Adddrss feilds End

      email: values?.email ? values?.email : signedEmail,



      PERMANENT_CELL_NO: (values?.Number?.substring(0, 2) == 92) ? "0" + values?.Number?.substring(2, 12) : values?.Number.slice(-12),


      // PERMANENT_CELL_NO: "03" + values?.Number.slice(-9),
      PERMANENT_EMAIL: values?.email ? values?.email : signedEmail,
      relationWithMobileNo: values?.CellPhone,
      number: (values?.Number?.substring(0, 2) == 92) ? "0" + values?.Number?.substring(2, 12) : values?.Number.slice(-12),










      // number: "03" + values?.Number.slice(-9),
      RELATIONSHIP: values?.CellPhone == 2 ? values?.proofRelation.value : '1',
      RELATIONSHIP_KEY: values?.CellPhone == 2 ? values?.proofRelation.children : 'Self',

      RELATIVE_NAME: values?.CellPhone == 2 ? values?.ProofRelationName : '',
      relativeCNIC: values?.CellPhone == 2 ? ((values?.proofRelation.children == 'Self' || values?.proofRelation.children == 'Company') ? '' : values?.RelativeCNIC) : '',
      RELATIVE_PROOF: values.ProofRelationFileName ? values.ProofRelationFileName : ProofRelationFileName1 ? ProofRelationFileName1 : '',
      RELATIVE_PROOF_UC: ProofRelationFileUnCompressedvar ? ProofRelationFileUnCompressedvar : values?.ProofRelationFileNameUC ? values?.ProofRelationFileNameUC : '',
      NAME_NMN: values?.addnominee == true ? (values?.NomineeName ? values?.NomineeName : '') : '',
      IDENTIFICATION_NMN: values?.addnominee == true ? (values?.NomineeIDType ? values?.NomineeIDType : '') : '',
      RELATIONSHIP_NMN: values?.addnominee == true ? (values?.NomineeRelation?.value ? values?.NomineeRelation?.value : '') : '',
      RELATIONSHIP_NMN_KEY: values?.addnominee == true ? (values?.NomineeRelation?.children ? values?.NomineeRelation?.children : '') : '',
      CNIC_NMN: values?.addnominee == true ? (values?.NomineeIDNumber ? values?.NomineeIDNumber : '') : '',
      CNIC_ISSUE_DATE_NMN: values?.addnominee == true ? (values?.NomineeIssueDate ? values?.NomineeIssueDate : '') : '',
      CNIC_EXPIRY_DATE_NMN: values?.addnominee == true ? (values?.NomineeLifeTimeExpiry == true ? '' : values?.NomineeExpiryDate) : '',
      CNIC_LIFETIME_NMN: values?.addnominee == true ? (values?.NomineeLifeTimeExpiry ? JSON.stringify(values?.NomineeLifeTimeExpiry) : "false") : '',

      // ************************************  below section for Income Detail  ***************************************
      idType: values?.IDType,
      CNIC: values?.CNIC,
      issueDate: values?.IssueDate,
      DATE_OF_EXPIRY: values?.lifeTimeExpiry == true ? '' : values?.ExpiryDate,
      LIFETIME_KEY: values?.lifeTimeExpiry ? JSON.stringify(values?.lifeTimeExpiry) : "false",
      IBAN: values.IBAN,
      BANK_NAME: values?.BankName,
      // employmentStatus: values.EmploymentStatus,
      EMPLOYER_NAME: values?.CompName,
      OCCUPATION: values?.BussType?.value ? values?.BussType?.value : "",
      OCCUPATION_KEY: values?.BussType?.children ? values?.BussType?.children : "",
      JOB_TITLE: values?.JobTitle,
      Department: values?.Department,
      OTHER_OCCUPATION: values?.BussType?.children == "Other" ? values?.OtherOccupation : '',
      // for Now Employee Apartment is removed from income detail section
      // employeeApt:values?.EmployApt,

      GROSS_ANNUAL_INCOME: values?.AnnualIncome?.value ? values?.AnnualIncome?.value : "",
      GROSS_ANNUAL_INCOME_KEY: values?.AnnualIncome?.children ? values?.AnnualIncome?.children : "",
      ZAKAT_STATUS: values?.Zakat?.value ? values?.Zakat?.value : "",
      ZAKAT_STATUS_KEY: values?.Zakat?.children ? values?.Zakat?.children : "",
      // Remittance: values?.BasisOfRemittance?.value ? values?.BasisOfRemittance?.value : "",
      // RemittanceKey: values?.BasisOfRemittance?.children ? values?.BasisOfRemittance?.children : "",
      Remittance: remitanceValue,
      RemittanceKey: remitanceName,
      SOURCE_OF_INCOME: values?.sourceofincome, // this feild still need to be manage on screen not in figma
      UKN: values?.UKN,
      MOTHER_MAIDEN_NAME: values?.MOTHER_MAIDEN_NAME,
      // ************************* below Section for Documentations *****************************************
      CNIC_FRONT: values?.CNICFileFrontName ? values?.CNICFileFrontName : '',
      CNIC_BACK: values?.CNICFileBackName ? values?.CNICFileBackName : '',
      ADD_PROOF: values?.sendSalerySlipName ? values?.sendSalerySlipName : "",

      //  below Section for Terms and conditions
      TERMS_CONDITIONS: "Y", //what to send in this?

      // Not found for following

      proofofRelationship: "",
      Client_Code: "",
      TELEPHONE_OFFICE: "",
      TELEPHONE_RESIDENCE: "",
      FAX: "",
      // PERMANENT_COUNTRY: values?.mailCountry?.value,

      PERMANENT_TELEPHONE_OFFICE: "",
      PERMANENT_TELEPHONE_RESIDENCE: "",
      PERMANENT_FAX: "",
      // OTHER_OCCUPATION: "",
      EMP_ADD_PROOF: "",
      SIGNATURE_PROOF: "",
      // TERMS_CONDITIONS: "",
      ProofofIBAN: "",
      // ZAKAAT_DECLARATION: "",
      // Remittance: "",

      // These are to be send empty for Now
      Salutation_ATR: "",
      CLIENT_NAME_ATR: "",
      IDENTIFICATION_ATR: "",
      CNIC_ATR: "",
      CNIC_EXPIRY_DATE_ATR: "",
      CNIC_LIFETIME_ATR: "",
      Mobile_ATR: "",
      Email_ATR: "",
      Mailing_ADDRESS_ATR_1: "",
      Mailing_ADDRESS_ATR_2: "",
      Mailing_ADDRESS_ATR_3: "",
      Mailing_Country_ATR: "",
      Mailing_Province_ATR: "",
      Other_Mailing_Prov_ATR: "",
      Mailing_CITY_ATR: "",
      Other_Mailing_CITY_ATR: "",
      Landline_ATR: "",
      FAX_ATR: "",
      COMP_STATUS: "false"
    };
    console.log('on continue params are ===========?????? <<<<<<<<<<<<<<', params)

    axios
      .post("account-details/", params)
      .then((value) => {
        console.log('value is-=================>>>', value)
        // setsendingReq(false);
        // alert('2')

        nextStep()
        setBackAndContinueBtnStatus(false)
      })
      .catch(function (error) {
        // setsendingReq(false);
        console.log('exception error is is-=================>>>', error.status)

        setBackAndContinueBtnStatus(false)
        setErrorMessage(true)
        console.log(error.response);
      });

  }
  const submitForm = () => {

    // let obj = {
    //   provinceList: values?.residentiaProvinceList,
    //   cityList: values?.residentialCitiesList
    // }

    localStorage.setItem("save&exist", "true");



    let params = {
      uid: JSON.parse(localStorage.getItem("user"))?.user_id,
      status: false, // status true for submition and false for save and exist
      RelationUS: values?.USResident,
      NonRelationUSPAK: values?.TaxPayer,
      RelationOrganization: values?.AssoiciatedEmployee,
      EarnIncome: values?.EarnIncome,
      // below section for Personal  Detail
      ACCOUNT_TYPE: values?.Type?.value,
      ACCOUNT_TYPE_KEY: values?.Type?.children,
      //ACCOUNT_TYPE: 'NKA',
      //ACCOUNT_TYPE_KEY: 'Normal Account',
      SALUTATION: values?.Salutations.value,
      SALUTATION_KEY: values?.Salutations?.children?.toUpperCase(),

      firstName: values?.firstName,
      lastName: values?.lastName,
      PLACE_OF_BIRTH: values?.placeOfBirth,
      GENDER: values?.Gender,
      MARITAL_STATUS: values?.MaritalStatus,
      RELATIONSHIP1: values?.Relation?.value,
      RELATIONSHIP1_KEY: values?.Relation?.children,

      FATHER_HUSBAND_NAME: values?.RelativeName,
      DATE_OF_BIRTH: values?.BirthDay,
      NATIONALITY: values?.Citizenship?.value,
      NATIONALITY_KEY: values?.Citizenship?.children,
      residentialStatus: values?.IDType == 'NICOP' || values?.IDType == 'POC' ? "02" : "01",
      RESIDENT_KEY: values?.IDType == 'NICOP' || values?.IDType == 'POC' ? "Non-Resident" : "Resident",
      // Residential Adddrss feilds start
      PERMANENT_ADDRESS_1: values?.Apt,
      PERMANENT_ADDRESS_2: values?.street,
      // PERMANENT_ADDRESS_3: values?.PermannentAddressLine3 ? values?.PermannentAddressLine3 : values?.country?.iso3,
      // MAILING_ADDRESS_3: values?.MailingAddressLine3 ? values?.MailingAddressLine3 : values?.mailCountry?.label ? values?.mailCountry?.label : values?.mailCountry?.iso3,
      PERMANENT_ADDRESS_3: values?.PermannentAddressLine3 ? values?.PermannentAddressLine3 : values?.country?.label,
      // MAILING_ADDRESS_3: values?.MailingAddressLine3 ? values?.MailingAddressLine3 : values?.country?.label ? values?.country?.label : values?.country?.iso3 || values?.country?.iso2,
      MAILING_ADDRESS_3: values?.MailingAddressLine3 ? values?.MailingAddressLine3 : values?.mailCountry?.label ? values?.mailCountry?.label : values?.mailCountry?.iso3 || values?.mailCountry?.iso2,

      // Xb: obj ,


      PROOF_OF_ADDRESS: values?.PermanentProofOfAddressCheckbox == false ? (values.PermanentProofRelationFileName ? values.PermanentProofRelationFileName : PermanentProofRelationFileparam ? PermanentProofRelationFileparam : '') : '',
      PROOF_OF_ADDRESS_TYPE: values?.PermanentProofOfAddressCheckbox == false ? (values?.permanentProofOfAddressType?.children ? values?.permanentProofOfAddressType?.children : "") : '',

      // Residential Adddrss feilds start

      // Mailing Adddrss feilds start
      Xd: values?.MailingAddress == false ? "true" : "false",
      MAILING_ADDRESS_2: values?.MailingAddress == false ? values?.Mailstreet : values?.street,
      MAILING_ADDRESS_1: values?.MailingAddress == false ? values?.MailApt : values?.Apt,




      COUNTRY: values?.MailingAddress == false ?
        (values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan') ?
          values?.mailCountry?.iso3 : values?.mailCountry?.iso2
        : (values?.country?.children == 'Pakistan' || values?.country?.label == 'Pakistan') ? values?.country?.iso3 : values?.country?.iso2,




      // COUNTRY_KEY: values?.country?.label || values?.country?.children,
      COUNTRY_KEY: values?.mailCountry?.label || values?.mailCountry?.label ? values?.mailCountry?.label : values?.mailCountry?.iso3,




      CITY_TOWN_VILLAGE: values?.MailingAddress == false ?
        (values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan') ? values?.MailCity?.City_Code || values?.MailCity?.label : '' :

        (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? values?.City?.City_Code || values?.City?.label : '',





      CITY_TOWN_VILLAGE_KEY: values?.MailingAddress == false ? values?.MailCity?.label : values?.City?.label,


      PROVINCE_STATE: values?.MailingAddress == false ?

        ((values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan')
          ? values?.MailProvinces?.Province_code || values?.MailProvinces?.state_code : '')


        : (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? values?.Provinces?.Province_code || values?.Provinces?.state_code : '',

      PROVINCE_STATE_KEY: values?.MailingAddress == false ? values?.MailProvinces?.label : values?.Provinces?.label,
      OTHERPROVINCE_STATE: values?.MailingAddress == false ? (values?.mailCountry?.label != 'Pakistan' && values?.mailCountry?.children != 'Pakistan') ? values?.MailProvinces?.label : "" : (values?.country?.label != 'Pakistan' && values?.country?.children != 'Pakistan') ? values?.Provinces?.Province_code || values?.Provinces?.state_code : '',
      OTHERCITY_TOWN_VILLAGE: values?.MailingAddress == false ?
        ((values?.mailCountry?.label != 'Pakistan' && values?.mailCountry?.children != 'Pakistan') ? values?.MailCity?.label : "") :

        (values?.country?.label != 'Pakistan' && values?.country?.children != 'Pakistan') ? values?.City?.City_Code || values?.City?.label : '',





      // permanent country list

      PERMANENT_COUNTRY: (values?.country?.children == 'Pakistan' || values?.country?.label == 'Pakistan') ? values?.country?.iso3 : values?.country?.iso2 || values?.country?.iso3,
      COUNTRY1_KEY: values?.country?.label || values?.country?.children,
      PERMANENT_PROVINCE: (values?.country?.children !== 'Pakistan' && values?.country?.label !== 'Pakistan') ? '' : values?.Provinces?.Province_code || values?.Provinces?.state_code,
      PROVINCE_KEY: values?.Provinces?.label,
      PERMANENT_CITY_TOWN: (values?.country?.children !== 'Pakistan' && values?.country?.label !== 'Pakistan') ? '' : values?.City?.City_Code || values?.City?.label,
      PERMANENT_CITY_TOWN_VILLAGE_KEY: values?.City?.label,

      PERMANENT_OTHERPROVINCE: (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? "" : values?.Provinces?.Province_code || values?.Provinces?.state_code,
      PERMANENT_OTHERCITY_TOWN: (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? "" : values?.City?.City_Code ? values?.City?.City_Code : values?.City?.label,
      EMPLOYER_ADDRESS: values?.EmployStreet ? values?.EmployStreet : "",








      PROOF_OF_ADDRESS_MAILING: values?.MailingProofOfAddressCheckbox == false ? (values.MailingProofRelationFileName ? values.MailingProofRelationFileName : MailingProofRelationFileparam ? MailingProofRelationFileparam : '') : '',
      PROOF_OF_ADDRESS_MAILING_TYPE: values?.MailingProofOfAddressCheckbox == false ? (values?.mailingProofOfAddressType?.children ? values?.mailingProofOfAddressType?.children : "") : '',




      // Mailing Adddrss feilds End

      email: values?.email ? values?.email : signedEmail,



      PERMANENT_CELL_NO: (values?.Number?.substring(0, 2) == 92) ? "0" + values?.Number?.substring(2, 12) : values?.Number.slice(-12),


      // PERMANENT_CELL_NO: "03" + values?.Number.slice(-9),
      PERMANENT_EMAIL: values?.email ? values?.email : signedEmail,
      relationWithMobileNo: values?.CellPhone,
      number: (values?.Number?.substring(0, 2) == 92) ? "0" + values?.Number?.substring(2, 12) : values?.Number.slice(-12),










      // number: "03" + values?.Number.slice(-9),
      RELATIONSHIP: values?.CellPhone == 2 ? values?.proofRelation.value : '1',
      RELATIONSHIP_KEY: values?.CellPhone == 2 ? values?.proofRelation.children : 'Self',

      RELATIVE_NAME: values?.CellPhone == 2 ? values?.ProofRelationName : '',
      relativeCNIC: values?.CellPhone == 2 ? ((values?.proofRelation.children == 'Self' || values?.proofRelation.children == 'Company') ? '' : values?.RelativeCNIC) : '',
      RELATIVE_PROOF: values.ProofRelationFileName ? values.ProofRelationFileName : ProofRelationFileName1 ? ProofRelationFileName1 : '',
      RELATIVE_PROOF_UC: ProofRelationFileUnCompressedvar ? ProofRelationFileUnCompressedvar : values?.ProofRelationFileNameUC ? values?.ProofRelationFileNameUC : '',
      NAME_NMN: values?.addnominee == true ? (values?.NomineeName ? values?.NomineeName : '') : '',
      IDENTIFICATION_NMN: values?.addnominee == true ? (values?.NomineeIDType ? values?.NomineeIDType : '') : '',
      RELATIONSHIP_NMN: values?.addnominee == true ? (values?.NomineeRelation?.value ? values?.NomineeRelation?.value : '') : '',
      RELATIONSHIP_NMN_KEY: values?.addnominee == true ? (values?.NomineeRelation?.children ? values?.NomineeRelation?.children : '') : '',
      CNIC_NMN: values?.addnominee == true ? (values?.NomineeIDNumber ? values?.NomineeIDNumber : '') : '',
      CNIC_ISSUE_DATE_NMN: values?.addnominee == true ? (values?.NomineeIssueDate ? values?.NomineeIssueDate : '') : '',
      CNIC_EXPIRY_DATE_NMN: values?.addnominee == true ? (values?.NomineeLifeTimeExpiry == true ? '' : values?.NomineeExpiryDate) : '',
      CNIC_LIFETIME_NMN: values?.addnominee == true ? (values?.NomineeLifeTimeExpiry ? JSON.stringify(values?.NomineeLifeTimeExpiry) : "false") : '',

      // *********************   below section for Income Detail  ***************************************
      idType: values?.IDType,
      CNIC: values?.CNIC,
      issueDate: values?.IssueDate,
      DATE_OF_EXPIRY: values?.lifeTimeExpiry == true ? '' : values?.ExpiryDate,
      LIFETIME_KEY: values?.lifeTimeExpiry ? JSON.stringify(values?.lifeTimeExpiry) : "false",
      IBAN: values.IBAN,
      BANK_NAME: values?.BankName,
      // employmentStatus: values.EmploymentStatus,
      EMPLOYER_NAME: values?.CompName,
      OCCUPATION: values?.BussType?.value ? values?.BussType?.value : "",
      OCCUPATION_KEY: values?.BussType?.children ? values?.BussType?.children : "",
      JOB_TITLE: values?.JobTitle,
      Department: values?.Department,
      OTHER_OCCUPATION: values?.BussType?.children == "Other" ? values?.OtherOccupation : '',
      // for Now Employee Apartment is removed from income detail section
      // employeeApt:values?.EmployApt,

      GROSS_ANNUAL_INCOME: values?.AnnualIncome?.value ? values?.AnnualIncome?.value : "",
      GROSS_ANNUAL_INCOME_KEY: values?.AnnualIncome?.children ? values?.AnnualIncome?.children : "",
      ZAKAT_STATUS: values?.Zakat?.value ? values?.Zakat?.value : "",
      ZAKAT_STATUS_KEY: values?.Zakat?.children ? values?.Zakat?.children : "",
      // Remittance: values?.BasisOfRemittance?.value ? values?.BasisOfRemittance?.value : "",
      // RemittanceKey: values?.BasisOfRemittance?.children ? values?.BasisOfRemittance?.children : "",
      Remittance: remitanceValue,
      RemittanceKey: remitanceName,
      SOURCE_OF_INCOME: values?.sourceofincome, // this feild still need to be manage on screen not in figma
      UKN: values?.UKN,
      MOTHER_MAIDEN_NAME: values?.MOTHER_MAIDEN_NAME,
      // ************************* below Section for Documentations *****************************************
      CNIC_FRONT: values?.CNICFileFrontName ? values?.CNICFileFrontName : '',
      CNIC_BACK: values?.CNICFileBackName ? values?.CNICFileBackName : '',
      ADD_PROOF: values?.sendSalerySlipName ? values?.sendSalerySlipName : "",

      //  below Section for Terms and conditions
      TERMS_CONDITIONS: "Y", //what to send in this?

      // Not found for following

      proofofRelationship: "",
      Client_Code: "",
      TELEPHONE_OFFICE: "",
      TELEPHONE_RESIDENCE: "",
      FAX: "",
      // PERMANENT_COUNTRY: values?.mailCountry?.value,

      PERMANENT_TELEPHONE_OFFICE: "",
      PERMANENT_TELEPHONE_RESIDENCE: "",
      PERMANENT_FAX: "",
      // OTHER_OCCUPATION: "",
      EMP_ADD_PROOF: "",
      SIGNATURE_PROOF: "",
      // TERMS_CONDITIONS: "",
      ProofofIBAN: "",
      // ZAKAAT_DECLARATION: "",
      // Remittance: "",

      // These are to be send empty for Now
      Salutation_ATR: "",
      CLIENT_NAME_ATR: "",
      IDENTIFICATION_ATR: "",
      CNIC_ATR: "",
      CNIC_EXPIRY_DATE_ATR: "",
      CNIC_LIFETIME_ATR: "",
      Mobile_ATR: "",
      Email_ATR: "",
      Mailing_ADDRESS_ATR_1: "",
      Mailing_ADDRESS_ATR_2: "",
      Mailing_ADDRESS_ATR_3: "",
      Mailing_Country_ATR: "",
      Mailing_Province_ATR: "",
      Other_Mailing_Prov_ATR: "",
      Mailing_CITY_ATR: "",
      Other_Mailing_CITY_ATR: "",
      Landline_ATR: "",
      FAX_ATR: "",
      COMP_STATUS: "false"
    };


    axios
      .post("account-details/", params)
      .then((value) => {
        setsendingSaveReq(false);
        if (value.data) {
          openSaveExitModel();
        }
      })
      .catch(function (error) {
        setsendingSaveReq(false);

        console.log(error.response);
      });

  }


  const hanldeResendentialCountries = (e) => {
    console.log({ e })
    hanldeResidentailProvincesAndCities('')
    handleDrctChange("City", '')
    handleDrctChange("country", e)
    handleDrctChange("residentiaProvinceList", e.states)

  }
  const hanldeResidentailProvincesAndCities = (e) => {

    handleDrctChange("Provinces", e)
    handleDrctChange("residentialCitiesList", e.cities)

    handleDrctChange("City", '')

  }





  const hanldeMailCountries = (e) => {
    handleDrctChange("mailProvinceList", e.states)
    handleDrctChange("mailCountry", e)
    hanldeMailProvincesAndCities('')
    handleDrctChange("MailCity", '')
  }
  const hanldeMailProvincesAndCities = (e) => {
    console.log(e)
    handleDrctChange("MailProvinces", e)
    handleDrctChange("mailCitiesList", e?.cities)
    handleDrctChange("MailCity", '')
    // setMailCity(e.cities)
  }

  const onSearch = (val) => {
    console.log('search:', val);
  }


  let tooltipText = "Add your exact name as per your CNIC / Identity Document."
  return (
    <>

      <div className="container-fluid px-0 bg-grey-100 py-5">
        <PersonalInfo handleDrctChange={handleDrctChange} values={values} />

        <div className="container px-0">
          <div className="mt-80">
            <div className="px-3">
              <div className="d-inline-flex w-100">
                <h1 className="fs32 ls4 fw-800 t-grey-800">Personal Information</h1>
              </div>
              <form onSubmit={SaveOnContinueSubmit} className="form" id="AOF-form">


                <div className="">
                  <div className="mb-3 row d-flex flex-column">
                    <label
                      htmlFor="AccountType"
                      className="col-12 col-form-label fw-500"
                    >
                      Account Type

                      <Tooltip overlayStyle={{ maxWidth: '470px' }} title={
                        <>
                          <p className="fw-500 fs14 text-white">

                            A Sahulat account is a training wheels account introduced for students, homemakers, and first time investors. This account reduces the checks made on your source of income as compared to a Normal account. To shield investors from unnecessary risk some functionalities are restricted. These include: total investment can't exceed PKR 800,000 , investment in lending based products is restricted, only a single Sahulat account can be opened.<br /> <br />Normal accounts have no restrictions. <br /> <br />The amount of information required to open either a Sahulat or a Normal account is the same.


                          </p>
                        </>
                      } placement="bottom"



                      >
                        <span className="ml10">
                          <HelpIcon />
                        </span>


                      </Tooltip>

                    </label>

                    <div className="col-12 col-sm-6 col-lg-4 mt-auto">
                      <>


                        <Select defaultValue={values.Type} onSelect={(value, event) => handleDrctChange("Type", event)} placeholder="Account Type" rules={[{ required: true }]} >

                          {Type.map(type => (

                            <Option key={type.value}>{type.label}</Option>

                          ))}


                        </Select>
                        {/*
                        <input
                          type="text"
                          name="Type"
                          className="form-control"

                          value="Normal Account"
                          onChange={handleChange}
                          id="Type"
                          minLength="1"
                          maxLength="120"
                          required={true}
                          disabled
                        // title="Only Alphabets are allowed"
                        />
                        */}
                        {values.Type.value == "" && <RequiredFeild />}
                      </>
                    </div>
                  </div>

                  <div className="row">

                    <div className="col-12 col-sm-6 col-lg-4 mb-3 d-flex flex-column mb-3">
                      <label htmlFor="Salutations" className="col-12 col-form-label fw-500">
                        Salutation
                        <Tooltip title="This helps us understand how we can address you." placement="bottom">
                          <span className="ml10">
                            <HelpIcon />
                          </span>
                        </Tooltip>
                      </label>
                      <div className="mt-auto">
                        <Form.Item rules={[{ required: true, message: 'Please select Salutations' }]} >
                          <Select defaultValue={values.Salutations ? values.Salutations : undefined} placeholder="Select any one" onSelect={(value, event) => handleDrctChange("Salutations", event)} >
                            {Salutations.map(salutations => (
                              <Option key={salutations.value}>{salutations.label}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                        {!values.Salutations?.value && <RequiredFeild />}
                        {!values.Salutations?.value ? <span id="salutation" className="text-danger fs10" style={{ display: "none" }} >Please fill LastName this</span> : ""}
                      </div>
                    </div>

                    <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column">
                      <label
                        htmlFor="first Name"
                        className="col-12 col-form-label fw-500"
                      >
                        Full Legal Name
                        <Tooltip title={tooltipText} placement="bottom"



                        >
                          <span className="ml10">
                            <HelpIcon />
                          </span>


                        </Tooltip>
                      </label>
                      <div className="col-12 mb-3 ">
                        <input
                          type="text"
                          name="firstName"
                          className="form-control mt-auto"
                          placeholder="Sehrish Ahmed Khan"
                          value={values?.firstName}
                          onChange={handleChange}
                          id="first Name"
                          minLength="1"
                          maxLength="120"
                          required={true}
                          title="Only Alphabets are allowed"
                          disabled={values?.editFormStatus == "true"}

                        />
                        {!values.firstName && values.continues ? <span className="text-danger fs10"  >Please provide first name</span> : ""}
                      </div>
                    </div>

                    <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column">
                      <label htmlFor="last Name" className="col-12 col-form-label fw-500">
                        Preferred Name
                        <Tooltip title="Let us know how we should refer to you. This could either be a nickname or just your first name." placement="bottom">
                          <span className="ml10">
                            <HelpIcon />
                          </span>
                        </Tooltip>
                      </label>
                      <div className="col-12 mb-3 ">
                        <input
                          type="text"
                          name="lastName"
                          className="form-control mt-auto"
                          placeholder="Sehrish"
                          value={values.lastName}
                          onChange={handleChange}
                          id="Last Name"
                          required={true}
                          title="Only Alphabets are allowed"
                        />
                        {!values.lastName ? <span id="lastname" className="text-danger fs10" style={{ display: "none" }} >Please fill LastName this</span> : ""}
                      </div>
                    </div>

                    <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                      <label htmlFor="Male" className="col-12 col-form-label fw-500">
                        Gender
                      </label>
                      <ul className="text-center combineButton RadioToButton px-0 d-flex justify-content-center mt-auto mb-0">
                        <li className="w-50 br-right">
                          <input
                            type="radio"
                            id="Male"
                            name="Gender"
                            value="Male"
                            defaultChecked={values.Gender == "Male"}
                            onChange={handleChange}
                            required={true}
                          />
                          <label htmlFor="Male" className="btn-txt mb-0">
                            Male
                          </label>
                        </li>
                        <li className="w-50">
                          <input
                            type="radio"
                            id="Female"
                            name="Gender"
                            value="Female"
                            defaultChecked={values.Gender == "Female"}
                            onChange={handleChange}
                            required={true}
                          />
                          <label htmlFor="Female" className="btn-txt mb-0">
                            Female
                          </label>
                        </li>
                      </ul>
                      {!values.Gender ? <span id="Gender" className="text-danger fs10" style={{ display: "none" }} >Please fill Gender</span> : ""}
                    </div>

                    <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                      <label htmlFor="Single" className="col-12 col-form-label fw-500">
                        Marital Status
                      </label>
                      <ul className="text-center combineButton RadioToButton px-0 d-flex justify-content-center mt-auto mb-0">
                        <li className="w-50 br-right">
                          <input
                            type="radio"
                            id="Single"
                            name="MaritalStatus"
                            value="S"
                            defaultChecked={values.MaritalStatus == "S"}
                            onChange={handleChange}
                            required={true}
                          />
                          <label htmlFor="Single" className="btn-txt mb-0">
                            Single
                          </label>
                        </li>
                        <li className="w-50">
                          <input
                            type="radio"
                            id="Married"
                            name="MaritalStatus"
                            value="M"
                            defaultChecked={values.MaritalStatus == "M"}
                            onChange={handleChange}
                            required={true}
                          />
                          <label htmlFor="Married" className="btn-txt mb-0">
                            Married
                          </label>
                        </li>
                      </ul>
                      {!values.MaritalStatus ? <span id="MaritalStatus" className="text-danger fs10" style={{ display: "none" }} >Please fill Marital Status</span> : ""}
                    </div>

                    <div className="col-12 col-sm-6 col-lg-4 mb-3 d-flex flex-column">
                      <label
                        htmlFor="Relative"
                        className="col-12 col-form-label fw-500"
                      >
                        Provide Father's or Husband's Name
                        <Tooltip overlayStyle={{ maxWidth: '256px' }} title="Every CNIC / identity document has either your father's or husband's name. Add the relative present on your CNIC / identity document." placement="bottom"
                        >
                          <span className="ml10">
                            <HelpIcon />
                          </span>
                        </Tooltip>
                      </label>
                      <div className="mt-auto">
                        <Select defaultValue={values.Relation ? values.Relation : undefined} placeholder="Select any one" onSelect={(value, event) => handleDrctChange("Relation", event)} rules={[{ required: true }]}>
                          {Realtions.map(realtions => (
                            <Option key={realtions.value}>{realtions.label}</Option>
                          ))}
                        </Select>
                      </div >
                      {!values.Relation.value && <RequiredFeild />}
                      {!values.Relation.value ? <span id="Relation" className="text-danger fs10" style={{ display: "none" }} >Please provide the Relation</span> : ""}
                    </div >

                    <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                      <label htmlFor="RelativeName" className="col-form-label fw-500">
                        Father's or Husband's Full Name
                      </label>
                      <input
                        type="text"
                        name="RelativeName"
                        className="form-control mt-auto"
                        placeholder="Ajmal Ali"
                        onChange={handleChange}
                        value={values.RelativeName}
                        id="RelativeName"
                        maxLength="40"
                        required={true}
                      />
                      {!values.RelativeName ? <span id="relativename" className="text-danger fs10" style={{ display: "none" }} >Relative Name Required</span> : ""}
                    </div>

                    <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                      <label htmlFor="Day" className="col-form-label fw-500">
                        Date of Birth (e.g. 28-02-1995)
                        <Tooltip overlayStyle={{ maxWidth: '280px' }} title="Only numbers and dashes are accepted." placement="bottom"
                        >
                          <span className="ml10">
                            <HelpIcon />
                          </span>
                        </Tooltip>
                      </label>



                      <DatePickerInput
                        onChange={(e) =>
                          onChangeDate(
                            e,
                            "BirthDay",
                            new Date("05/11/2019"),
                            new Date()
                          )
                        }

                        maxLength="10"
                        className="my-custom-datepicker-component mt-auto"
                        defaultValue={
                          values?.BirthDay?.includes("N") ? "" : values?.BirthDay
                        }

                        name="DatePicker"
                        startDate={
                          new Date(
                            new Date().setFullYear(
                              new Date().getFullYear() - 18
                            )
                          )
                        }

                        // readOnly
                        placeholder="dd-mm-yyyy"
                        maxDate={
                          new Date(
                            new Date().setFullYear(
                              new Date().getFullYear() - 18
                            )
                          )
                        }

                        showOnInputClick={true}
                        format="DD-MM-YYYY"
                        displayFormat="DD-MM-YYYY"
                        required={true}
                      />

                      {!values?.BirthDay ? <span id="birthday" className="text-danger fs10" style={{ display: "none" }} >Please select Birthday</span> : ""}

                      {values.BirthDay === "" && <RequiredFeild />}
                    </div>

                    <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column">
                      <label htmlFor="placeOfBirth" className="col-12 col-form-label fw-500">
                        Place of Birth
                        <Tooltip title="Enter your place of birth like town, city or country." placement="bottom">
                          <span className="ml10">
                            <HelpIcon />
                          </span>
                        </Tooltip>
                      </label>
                      <div className="col-12 mb-3 ">
                        <input
                          type="text"
                          name="placeOfBirth"
                          className="form-control mt-auto"
                          placeholder="Town/City/Country"
                          value={values.placeOfBirth}
                          onChange={handleChange}
                          id="placeOfBirth"
                          required={true}
                          title="Only Alphabets are allowed"
                        />
                        {!values.placeOfBirth ? <span id="placeofbirth" className="text-danger fs10" style={{ display: "none" }} >Please fill Place of Birth</span> : ""}
                      </div>
                    </div>

                    <div className="col-12 col-sm-6 col-lg-4 mb-3 d-flex flex-column mb-3">
                      <label
                        htmlFor="Citizenship"
                        className="col-form-label fw-500"
                      >
                        Citizenship
                      </label>
                      <div className="mt-auto">
                        {/* <Select
                          onChange={(e) => handleDrctChange("Citizenship", e)}
                          placeholder="Select any one "
                          id="Citizenship"
                          options={countries}
                          defaultInputValue={values.Citizenship.label}
                        /> */}


                        <Select defaultValue={values.Citizenship ? values.Citizenship : undefined}
                          // showSearch
                          placeholder="Select any one"
                          onSelect={(value, event) => handleDrctChange("Citizenship", event)} rules={[{ required: true }]}
                          optionFilterProp="children"

                        >

                          {countries.map(country => (
                            <Option key={country.value}>{country.label}</Option>
                          ))}
                        </Select>
                      </div >

                      {!values.Citizenship?.value && <RequiredFeild />}
                      {!values.Citizenship?.value ? <span id="Citizenship" className="text-danger fs10" style={{ display: "none" }} >Please select citizenship</span> : ""}
                    </div >
                    <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                      <label
                        htmlFor="Resident"
                        className="col-form-label fw-500"

                      >
                        Resident Status in Pakistan

                      </label>
                      <div className="mt-auto">
                        {/* <Select
                          onChange={(e) => handleDrctChange("Resident", e)}
                          placeholder="Select any one " 
                          options={Residents}
                          defaultInputValue={values.Resident.label}
                        /> */}
                        <Select defaultValue={values.Resident ? values.Resident : undefined} placeholder="Select any one" onSelect={(value, event) => handleDrctChange("Resident", event)} rules={[{ required: true }]} disabled={values?.editFormStatus == "true"}>

                          {Residents.map(residents => (
                            <Option key={residents.value}>{residents.label}</Option>
                          ))}

                        </Select>
                      </div >
                      {!values.Resident ? <span id="Resident" className="text-danger fs10" style={{ display: "none" }} >Please select Resident</span> : ""}

                      {!values.Resident?.value && <RequiredFeild />}

                    </div >
                    <div className='mt-40'>
                      <hr className="t-grey-200 mt-40 mb-40"></hr>
                    </div>

                    <div className="d-inline-flex w-100 mt-40 d-flex flex-column mb-3">
                      <h2 className="fs18 fw-800 t-grey-800">Permanent Address


                        <Tooltip overlayStyle={{ maxWidth: '470px' }} title="If the address is different to the one on your CNIC / identity document, you'll need to provide proof of your residence." placement="bottom"



                        >
                          <span className="ml10">
                            <HelpIcon />
                          </span>


                        </Tooltip>

                      </h2>
                    </div>

                    <div className="col-12 col-sm-4 mb-3 d-flex flex-column">
                      <label htmlFor="Apt" className="col-form-label fw-500">
                        Address Line 1 (House & Street)
                        <Tooltip overlayStyle={{ maxWidth: '280px' }} title="Only the following special characters are allowed # * , . /" placement="bottom"
                        >
                          <span className="ml10">
                            <HelpIcon />
                          </span>
                        </Tooltip>
                      </label>

                      <input
                        type="text"
                        name="Apt"
                        className="form-control mt-auto"
                        placeholder="House 1 Shahrah e Faisal"
                        onChange={handleChange}
                        value={values.Apt}
                        id="Apt"
                        required={true}
                        maxLength="40"
                      />
                      {!values.Apt ? <span id="house" className="text-danger fs10" style={{ display: "none" }} >Please fill Apt</span> : ""}
                    </div>

                    <div className="col-12 col-sm-8 mb-3 d-flex flex-column">
                      <label
                        htmlFor="Address"
                        className="col-form-label fw-500"
                      >
                        Address Line 2 (Area)
                        <Tooltip overlayStyle={{ maxWidth: '280px' }} title="Only the following special characters are allowed # * , . /" placement="bottom"
                        >
                          <span className="ml10">
                            <HelpIcon />
                          </span>
                        </Tooltip>
                      </label>
                      <input
                        type="text"
                        name="street"
                        className="form-control mt-auto"
                        placeholder="Block 1 PECHS"
                        onChange={handleChange}
                        value={values.street}
                        id="street"
                        required={true}
                        maxLength="40"
                      />
                      {!values.street ? <span id="area" className="text-danger fs10" style={{ display: "none" }} >Please fill Street</span> : ""}

                    </div>




                    <div className="col-12 col-sm-12 mb-3 d-flex flex-column">
                      <label
                        htmlFor="PermannentAddressLine3"
                        className="col-form-label fw-500"
                      >
                        Address Line 3
                        <Tooltip overlayStyle={{ maxWidth: '280px' }} title="Only the following special characters are allowed # * , . /" placement="bottom"
                        >
                          <span className="ml10">
                            <HelpIcon />
                          </span>
                        </Tooltip>
                      </label>
                      {/*console.log(values?.PermannentAddressLine3, "values =======>>>>>>>>>>"), values?.iso3*/}
                      <input
                        type="text"
                        name="PermannentAddressLine3"
                        className="form-control mt-auto"
                        placeholder="Address line 3"
                        onChange={handleChange}
                        value={values?.PermannentAddressLine3}
                        id="PermannentAddressLine3"
                        required={false}
                        maxLength="100"
                      />
                      {!values.PermannentAddressLine3 ? <span id="area" className="text-danger fs10" style={{ display: "none" }} >Please fill Address Line3</span> : ""}

                    </div>

                    <div className="col-12 col-sm-6 col-lg-4 mb-3 d-flex flex-column">
                      <label
                        htmlFor="country"
                        className="col-form-label fw-500"
                      >
                        Country
                      </label>


                      <div className="mt-auto">


                        <Select1
                          onChange={(e) => hanldeResendentialCountries(e)}
                          // onChange={(e) => handleDrctChange("country", e)}
                          placeholder="Select any one"
                          id="country"
                          options={countriesStateCities}
                          defaultInputValue={values.country.label ? values.country.label : undefined}
                          defaultValue={values.country.label ? values.country.label : undefined}
                          value={values.country}
                          styles={{

                            control: (base, state) => ({
                              ...base,
                              '&:hover': { borderColor: '#E5E7EB' }, // border style on hover
                              border: '1px solid #E5E7EB', // default border color
                              height: "47px",
                              borderRadius: "0.5rem ",
                              boxShadow: 'none', // no box-shadow
                            }),
                          }}

                        />

                        {/* <Select defaultValue={values?.country} placeholder="Select any one" onChange={(e) => hanldeResendentialCountries(e)} >

                          {countriesStateCities?.map(countries => (
                            <Option key={countries}>{countries.label}</Option>
                          ))}

                        </Select> */}
                        {!values.country?.label && <RequiredFeild />}
                        {!values.country?.label && values.continues ? <span id="country" className="text-danger fs10" >Please select Country</span> : ""}
                      </div >
                    </div >


                    {/* {values.country.label == 'Pakistan' ? ( */}
                    <>
                      <div className="col-12 col-sm-6 col-lg-4 mb-3 d-flex flex-column">
                        <label
                          htmlFor="Provinces"
                          className="col-form-label fw-500"
                        >
                          Province/State
                        </label>
                        <div className="mt-auto">

                          <Select1
                            // onChange={(e) => handleDrctChange("Provinces", e)}
                            onChange={(e) => hanldeResidentailProvincesAndCities(e)}
                            placeholder="Select any one"
                            id="Provinces"
                            options={values?.residentiaProvinceList}
                            defaultValue={values.Provinces.label ? values.Provinces.label : undefined}
                            value={values.Provinces}
                            styles={{

                              control: (base, state) => ({
                                ...base,
                                '&:hover': { borderColor: '#E5E7EB' }, // border style on hover
                                border: '1px solid #E5E7EB', // default border color
                                height: "47px",
                                borderRadius: "0.5rem ",
                                boxShadow: 'none', // no box-shadow
                              }),
                            }}

                          />
                          {/* <Select defaultValue={values?.Provinces} placeholder="Select any one" onChange={(e) => hanldeResidentailProvincesAndCities(e)} >

                            {selectedResidentialProvince?.map(residentialProvince => (
                              <Option key={residentialProvince?.label}>{residentialProvince?.label}</Option>
                            ))}

                          </Select> */}

                          {!values?.Provinces?.label && <RequiredFeild />}
                          {!values?.Provinces?.label && values.continues ? <span id="province" className="text-danger fs10" >Please select Province</span> : ""}
                        </div >
                      </div >



                      <div className="col-12 col-sm-6 col-lg-4 mb-3 d-flex flex-column">
                        <label htmlFor="City" className="col-form-label fw-500">
                          City
                        </label>

                        <div className="mt-auto">
                          <Select1
                            onChange={(e) => handleDrctChange("City", e)}
                            placeholder="Select any one"
                            id="City"
                            options={values?.residentialCitiesList}
                            defaultValue={values.City.label ? values.City.label : undefined}
                            value={values.City}
                          />

                          {/* <Select defaultValue={values.City} placeholder="Select any one" onChange={(e) => handleDrctChange("City", e)} >

                          {residentialCity.map(residentialCity => (
                            <Option key={residentialCity.label}>{residentialCity.label}</Option>
                          ))}

                        </Select> */}
                          {!values.City?.label && <RequiredFeild />}
                          {!values?.City?.label && values.continues ? <span id="city" className="text-danger fs10" >Please select City</span> : ""}
                        </div >
                      </div >
                    </>
                    {/* // ) : (
                    //   <>
                    //     <div className="col-12 col-sm-6 col-lg-4">
                    //       <label
                    //         htmlFor="otherProvince"
                    //         className="col-form-label fw-500"
                    //       >
                    //         Other Province
                    //       </label>
                    //       <input
                    //         type="text"
                    //         name="otherProvince"
                    //         className="form-control mb-3"
                    //         placeholder=""
                    //         onChange={handleChange}
                    //         value={values.otherProvince}
                    //         id="otherProvince"
                    //         required
                    //       />
                    //     </div>

                    //     <div className="col-12 col-sm-6 col-lg-4">
                    //       <label
                    //         htmlFor="otherCities"
                    //         className="col-form-label fw-500"
                    //       >
                    //         Other Cities
                    //       </label>
                    //       <input
                    //         type="text"
                    //         name="otherCities"
                    //         className="form-control mb-3"
                    //         placeholder=""
                    //         onChange={handleChange}
                    //         value={values.otherCities}
                    //         id="otherCities"
                    //         required
                    //       />
                    //     </div>
                    //   </>
                    // )} */}






                  </div >

                  {/* new development for permenant proof of address type start */}


                  <div>

                    <div className="col-sm-9 col-md-10 my-auto mt-auto d-flex">
                      <input
                        className="form-check-input me-2 mb-3"
                        type="checkbox"
                        defaultChecked={values.PermanentProofOfAddressCheckbox}
                        onChange={handleChange}
                        name="PermanentProofOfAddressCheckbox"
                        id="PermanentProofOfAddressCheckbox"
                      />
                      <label
                        className="form-check-label fw-500 fs16 mailing-checkbox-label Bold"
                        htmlFor="PermanentProofOfAddressCheckbox"
                      >
                        Yes, my permanent address is mentioned on my ID
                      </label>
                    </div>

                    <div className="col-12">
                      <div className="row">
                        {!values.PermanentProofOfAddressCheckbox ? (
                          <>




                            <div className="col-12 col-sm-6 col-lg-4 mb-3 d-flex flex-column">
                              <label
                                htmlFor="permanentproofOfAddressType"
                                className="col-form-label fw-500"
                              >
                                Proof of Address Type


                                <Tooltip overlayStyle={{ maxWidth: '470px' }} title="Proof of address is a compulsory requirement from the regulator. This is a document that is in your name and mentions the address provided." placement="bottom"



                                >
                                  <span className="ml10">
                                    <HelpIcon />
                                  </span>


                                </Tooltip>
                              </label>
                              <div className="">


                                <Select defaultValue={values.permanentProofOfAddressType.children ? values.permanentProofOfAddressType.children : undefined} placeholder="Select any one" onSelect={(value, e) => handleDrctChange("permanentProofOfAddressType", e)} rules={[{ required: true }]} >

                                  {(PermanentProofOfAddressType).map(permanentProofOfAddressType => (
                                    <Option key={permanentProofOfAddressType.value}>{permanentProofOfAddressType.label}</Option>
                                  ))}

                                </Select>



                                {!values?.permanentProofOfAddressType?.children && <RequiredFeild />}
                                {/* {!values?.permanentProofOfAddressType?.label  ? <span id="permanentproofOfAddressType" className="text-danger fs10" >Please Select Proof of Address Type</span> : ""} */}

                              </div >
                            </div >


                            <>



                              <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                                <label
                                  htmlFor="PermanentProofRelationFile"
                                  className="col-form-label fw-500"
                                >
                                  Proof of Address

                                </label>


                                {values?.PermanentProofRelationFileName ? (
                                  <>
                                    <div className="d-block d-sm-table">
                                      <div className="Circularprogress yellow">
                                        {" "}
                                        <span className="Circularprogress-left">
                                          {" "}
                                          <span className="Circularprogress-bar"></span>{" "}
                                        </span>{" "}
                                        <span className="Circularprogress-right">
                                          {" "}
                                          <span className="Circularprogress-bar"></span>{" "}
                                        </span>
                                        <div className="Circularprogress-value t-pink fs12 fw-400">


                                          {values?.PermanentProofRelationFileName?.split(".").pop().toUpperCase()}
                                        </div>
                                      </div>

                                      <div className="fileName">
                                        <div>
                                          <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                            {" "}
                                            {values?.PermanentProofRelationFileName}
                                          </p>

                                        </div>
                                      </div>
                                    </div>
                                    <div className="my-3 bg-Pink cursor edge p-1">

                                      <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                                        className="mx-auto d-block"
                                        onClick={() =>
                                          handleDrctChange(
                                            "PermanentProofRelationFileName",
                                            ""
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    {values.PermanentProofRelationFile ? (
                                      <>
                                        {Object.keys(values.PermanentProofRelationFile).map(
                                          (x, index) => {

                                            return (
                                              <>
                                                <div className="d-block d-sm-table">
                                                  <div className="Circularprogress yellow">
                                                    {" "}
                                                    <span className="Circularprogress-left">
                                                      {" "}
                                                      <span className="Circularprogress-bar"></span>{" "}
                                                    </span>{" "}
                                                    <span className="Circularprogress-right">
                                                      {" "}
                                                      <span className="Circularprogress-bar"></span>{" "}
                                                    </span>
                                                    <div className="Circularprogress-value t-pink fs12 fw-400">
                                                      {getSecondPart(
                                                        values.PermanentProofRelationFile[x].type
                                                      ).toUpperCase()}
                                                    </div>
                                                  </div>

                                                  <div className="fileName">
                                                    {/* <div className="position-absolute ml-55"> */}
                                                    <div >
                                                      <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                                        {" "}
                                                        {values.PermanentProofRelationFile[x].name}
                                                      </p>
                                                      <div>
                                                        <p className="m-0 t-grey-400 fw-400 fs14 ">
                                                          {" "}
                                                          {Math.round(
                                                            values.PermanentProofRelationFileSize / 1024
                                                          )}{" "}
                                                          kb /
                                                          {Math.round(
                                                            values.PermanentProofRelationFileSize / 1024
                                                          )}{" "}
                                                          kb
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="my-3 cursor bg-Pink edge p-1">
                                                  {/* <img
                                                src={Cross}
                                                alt="cross"
                                                className="mx-auto d-block "
                                                onClick={() =>
                                                  handleDrctChange(
                                                    "PermanentProofRelationFile",
                                                    ""
                                                  )
                                                }
                                              /> */}

                                                  <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                                                    className="mx-auto d-block"
                                                    onClick={() =>
                                                      handleDrctChange(
                                                        "PermanentProofRelationFile",
                                                        ""
                                                      )
                                                    }
                                                  />
                                                </div>
                                              </>
                                            );
                                          }
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <input
                                          type="file"
                                          name="PermanentProofRelationFile"

                                          onChange={handleChange}
                                          value={values.PermanentProofRelationFile}
                                          // onChange={(e) => onFileResize(e)}
                                          className="custom-file-input lh0"
                                          accept="application/pdf ,.jpg, .jpeg, .png"
                                          required={true}
                                        />




                                      </>

                                    )}

                                  </>
                                )}




                                <div className="upload-cnic-hint mt8">
                                  The file uploaded must either be a PDF,PNG or JPEG file and  must be  5 MB or smaller
                                </div>



                              </div >



                            </>



                          </>
                        ) : (
                          <></>
                        )}
                      </div >
                    </div >
                  </div >

                  {/* new development for proof of address type end  */}































                  <div>

                    <div className="col-sm-9 col-md-10 my-auto mt-auto d-flex">
                      <input
                        className="form-check-input me-2 mb-3"
                        type="checkbox"
                        defaultChecked={values.MailingAddress}
                        onChange={handleChange}
                        name="MailingAddress"
                        id="MailingAddress"
                      />
                      <label
                        className="form-check-label fw-500 fs16 mailing-checkbox-label Bold"
                        htmlFor="MailingAddress"
                      >
                        My permanent and mailing addresses are the same
                      </label>
                    </div>
                    {!values.MailingAddress && (
                      <div className="d-inline-flex w-100 mailing-address-container mb-3">
                        <h2 className="fs18 fw-800 t-grey-800">Mailing Address
                          <Tooltip overlayStyle={{ maxWidth: '470px' }} title="If the address is different to the one on your CNIC / identity document, you'll need to provide proof of your residence." placement="bottom"



                          >
                            <span className="ml10">
                              <HelpIcon />
                            </span>


                          </Tooltip>
                        </h2>
                      </div>
                    )}
                    <div className="col-12">
                      <div className="row">
                        {!values.MailingAddress ? (
                          <>


                            <div className="col-12 col-sm-4 d-flex flex-column mb-3">
                              <label
                                htmlFor="MailApt"
                                className="col-form-label fw-500"
                              >
                                Address Line 1 (House & Street)
                                <Tooltip overlayStyle={{ maxWidth: '280px' }} title="Only the following special characters are allowed # * , . /" placement="bottom"
                                >
                                  <span className="ml10">
                                    <HelpIcon />
                                  </span>
                                </Tooltip>
                              </label>

                              <input
                                type="text"
                                name="MailApt"
                                className="form-control mt-auto"
                                placeholder="House & Street"
                                onChange={handleChange}
                                value={values.MailApt}
                                id="MailApt"
                                maxLength="40"
                                required={true}
                              />
                              {!values.MailApt && <RequiredFeild />}
                              {!values?.MailApt && values.continues ? <span id="mailApt" className="text-danger fs10" >Please fill Apt</span> : ""}
                            </div>

                            <div className="col-12 col-sm-8 d-flex flex-column mb-3">
                              <label
                                htmlFor="Mailstreet"
                                className="col-form-label fw-500"
                              >
                                Address Line 2 (Area)
                                <Tooltip overlayStyle={{ maxWidth: '280px' }} title="Only the following special characters are allowed # * , . /" placement="bottom"
                                >
                                  <span className="ml10">
                                    <HelpIcon />
                                  </span>
                                </Tooltip>
                              </label>
                              <input
                                type="text"
                                name="Mailstreet"
                                className="form-control mt-auto"
                                placeholder="Area"
                                onChange={handleChange}
                                value={values.Mailstreet}
                                id="Mailstreet"
                                required={true}
                                maxLength="40"
                              />
                              {!values.Mailstreet && <RequiredFeild />}
                              {!values?.Mailstreet && values.continues ? <span id="Mailstreet" className="text-danger fs10" >Please fill Street</span> : ""}
                            </div>

                            <div className="col-12 col-sm-12 mb-3 d-flex flex-column">
                              <label
                                htmlFor="MailingAddressLine3"
                                className="col-form-label fw-500"
                              >
                                Address Line 3
                                <Tooltip overlayStyle={{ maxWidth: '280px' }} title="Only the following special characters are allowed # * , . /" placement="bottom"
                                >
                                  <span className="ml10">
                                    <HelpIcon />
                                  </span>
                                </Tooltip>
                              </label>
                              <input
                                type="text"
                                name="MailingAddressLine3"
                                className="form-control mt-auto"
                                placeholder="Address line 3"
                                onChange={handleChange}
                                value={values?.MailingAddressLine3}
                                id="MailingAddressLine3"
                                required={false}
                                maxLength="100"
                              />
                              {!values.MailingAddressLine3 ? <span id="area" className="text-danger fs10" style={{ display: "none" }} >Please fill Address Line 3</span> : ""}

                            </div>



                            <div className="col-12 col-sm-6 col-lg-4 mb-3 d-flex flex-column">
                              <label
                                htmlFor="mailCountry"
                                className="col-form-label fw-500"
                              >
                                Country
                              </label>
                              <div className="mt-auto">

                                {/* {alert('2')} */}
                                <Select1
                                  onChange={(e) => hanldeMailCountries(e)}

                                  placeholder="Select any one"
                                  id="mailCountry"
                                  options={countriesStateCities}
                                  defaultValue={values.mailCountry?.label ? values.mailCountry?.label : undefined}
                                  defaultInputValue={values?.mailCountry?.label ? values?.mailCountry?.label : undefined}
                                  value={values?.mailCountry}
                                  styles={{

                                    control: (base, state) => ({
                                      ...base,
                                      '&:hover': { borderColor: '#E5E7EB' }, // border style on hover
                                      border: '1px solid #E5E7EB', // default border color
                                      height: "47px",
                                      borderRadius: "0.5rem ",
                                      boxShadow: 'none', // no box-shadow
                                    }),
                                  }}



                                />

                                {/* <Select defaultValue={values.mailCountry} placeholder="Select any one" onChange={(e) => hanldeMailCountries(e)} >

                                  {countriesStateCities.map(countriesStateCity => (
                                    <Option key={countriesStateCity.label}>{countriesStateCity.label}</Option>
                                  ))}

                                </Select> */}

                                {!values?.mailCountry?.label && <RequiredFeild />}
                                {!values?.mailCountry?.label && values.continues ? <span id="MailCountry" className="text-danger fs10" >Please Select Country</span> : ""}

                              </div >
                            </div >


                            {/* {values?.mailCountry?.label == 'Pakistan' ? ( */}
                            <>
                              <div className="col-12 col-sm-6 col-lg-4 mb-3 d-flex flex-column">
                                <label
                                  htmlFor="MailProvinces"
                                  className="col-form-label fw-500"
                                >
                                  Province/State
                                </label>

                                <div className="mt-auto">
                                  <Select1
                                    // onChange={(e) =>
                                    //   handleDrctChange("MailProvinces", e)
                                    // }
                                    onChange={(e) => hanldeMailProvincesAndCities(e)}
                                    placeholder="Select any one"
                                    id="MailProvinces"
                                    options={values?.mailProvinceList}
                                    defaultValue={values.MailProvinces.label ? values.MailProvinces.label : undefined}
                                    value={values?.MailProvinces}
                                    styles={{

                                      control: (base, state) => ({
                                        ...base,
                                        '&:hover': { borderColor: '#E5E7EB' }, // border style on hover
                                        border: '1px solid #E5E7EB', // default border color
                                        height: "47px",
                                        borderRadius: "0.5rem ",
                                        boxShadow: 'none', // no box-shadow
                                      }),
                                    }}


                                  />
                                  {/* <Select defaultValue={values.MailProvinces} placeholder="Select any one" onChange={(e) => hanldeMailProvincesAndCities(e)} >

                                    {selectedmailProvince.map(selectedmailProv => (
                                      <Option key={selectedmailProv.label}>{selectedmailProv.label}</Option>
                                    ))}

                                  </Select> */}
                                  {!values.MailProvinces?.label && <RequiredFeild />}
                                  {!values.MailProvinces?.label && values.continues ? <span id="MailCountry" className="text-danger fs10" >Please Select Country</span> : ""}
                                </div >


                              </div >


                              <div className="col-12 col-sm-6 col-lg-4 mb-3 d-flex flex-column">
                                <label
                                  htmlFor="MailCity"
                                  className="col-form-label fw-500"
                                >
                                  City
                                </label>
                                <div className="mt-auto">
                                  <Select1
                                    onChange={(e) =>
                                      handleDrctChange("MailCity", e)
                                    }
                                    placeholder="Select any one"
                                    id="MailCity"

                                    options={values?.mailCitiesList}
                                    defaultValue={values.MailCity.label ? values.MailCity.label : undefined}
                                    value={values?.MailCity}
                                  />

                                  {!values.MailCity?.label && <RequiredFeild />}
                                  {!values.MailCity?.label && values.continues ? <span id="MailCountry" className="text-danger fs10" >Please Select Country</span> : ""}
                                  {/* <Select defaultValue={values.MailCity} placeholder="Select any one" onChange={(e) => handleDrctChange("MailCity", e)} >

                                  {mailCity.map(mailcity => (
                                    <Option key={mailcity.label}>{mailcity.label}</Option>
                                  ))}

                                </Select> */}
                                </div >
                              </div >
                            </>
                            {/* // ) : (
                            //   <>
                            //     <div className="col-12 col-sm-6 col-lg-4">
                            //       <label
                            //         htmlFor="otherMailProvinces"
                            //         className="col-form-label fw-500"
                            //       >
                            //         Other Province
                            //       </label>
                            //       <input
                            //         type="text"
                            //         name="otherMailProvinces"
                            //         className="form-control mb-3"
                            //         placeholder=""
                            //         onChange={handleChange}
                            //         value={values.otherMailProvinces}
                            //         id="otherMailProvinces"
                            //         required
                            //       />
                            //     </div>

                            //     <div className="col-12 col-sm-6 col-lg-4">
                            //       <label
                            //         htmlFor="otherMailCity"
                            //         className="col-form-label fw-500"
                            //       >
                            //         Other Cities
                            //       </label>
                            //       <input
                            //         type="text"
                            //         name="otherMailCity"
                            //         className="form-control mb-3"
                            //         placeholder=""
                            //         onChange={handleChange}
                            //         value={values.otherMailCity}
                            //         id="otherMailCity"
                            //         required
                            //       />
                            //     </div>
                            //   </>
                            // )} */}




                            {/* new development for permenant proof of address type start Mailing */}


                            <div>

                              <div className="col-sm-9 col-md-10 my-auto mt-auto d-flex">
                                <input
                                  className="form-check-input me-2 mb-3"
                                  type="checkbox"
                                  defaultChecked={values.MailingProofOfAddressCheckbox}
                                  onChange={handleChange}
                                  name="MailingProofOfAddressCheckbox"
                                  id="MailingProofOfAddressCheckbox"
                                />
                                <label
                                  className="form-check-label fw-500 fs16 mailing-checkbox-label Bold"
                                  htmlFor="MailingProofOfAddressCheckbox"
                                >
                                  Yes, my mailing address is mentioned on my ID
                                </label>
                              </div>

                              <div className="col-12">
                                <div className="row">
                                  {!values.MailingProofOfAddressCheckbox ? (
                                    <>




                                      <div className="col-12 col-sm-6 col-lg-4 mb-3 d-flex flex-column">
                                        <label
                                          htmlFor="mailingproofOfAddressType"
                                          className="col-form-label fw-500"
                                        >
                                          Proof of Address Type


                                          <Tooltip overlayStyle={{ maxWidth: '470px' }} title="Proof of address is a compulsory requirement from the regulator. This is a document that is in your name and mentions the address provided." placement="bottom"



                                          >
                                            <span className="ml10">
                                              <HelpIcon />
                                            </span>


                                          </Tooltip>
                                        </label>
                                        <div className="">

                                          {console.log('==============>>>>>>>>>>>>>mailingProofOfAddressType', values?.mailingProofOfAddressType)}
                                          <Select defaultValue={values.mailingProofOfAddressType.children ? values.mailingProofOfAddressType.children : undefined} placeholder="Select any one" onSelect={(value, e) => handleDrctChange("mailingProofOfAddressType", e)} rules={[{ required: true }]} >

                                            {(MailingProofOfAddressType).map(mailingProofOfAddressType => (
                                              <Option key={mailingProofOfAddressType.value}>{mailingProofOfAddressType.label}</Option>
                                            ))}

                                          </Select>



                                          {!values?.mailingProofOfAddressType?.children && <RequiredFeild />}
                                          {/* {!values?.permanentProofOfAddressType?.label  ? <span id="permanentproofOfAddressType" className="text-danger fs10" >Please Select Proof of Address Type</span> : ""} */}

                                        </div >
                                      </div >


                                      <>



                                        <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">

                                          <label
                                            htmlFor="MailingProofRelationFile"
                                            className="col-form-label fw-500"
                                          >
                                            Proof of Address

                                          </label>

                                          {values?.MailingProofRelationFileName ? (
                                            <>
                                              <div className="d-block d-sm-table">
                                                <div className="Circularprogress yellow">
                                                  {" "}
                                                  <span className="Circularprogress-left">
                                                    {" "}
                                                    <span className="Circularprogress-bar"></span>{" "}
                                                  </span>{" "}
                                                  <span className="Circularprogress-right">
                                                    {" "}
                                                    <span className="Circularprogress-bar"></span>{" "}
                                                  </span>
                                                  <div className="Circularprogress-value t-pink fs12 fw-400">
                                                    {values?.MailingProofRelationFileName?.split(".").pop().toUpperCase()}
                                                  </div>
                                                </div>

                                                <div className="fileName">
                                                  <div>
                                                    <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                                      {" "}
                                                      {values?.MailingProofRelationFileName}
                                                    </p>

                                                  </div>
                                                </div>
                                              </div>
                                              <div className="my-3 bg-Pink cursor edge p-1">

                                                <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                                                  className="mx-auto d-block"
                                                  onClick={() =>
                                                    handleDrctChange(
                                                      "MailingProofRelationFileName",
                                                      ""
                                                    )
                                                  }
                                                />
                                              </div>
                                            </>
                                          ) : (
                                            <>
                                              {values.MailingProofRelationFile ? (
                                                <>
                                                  {Object.keys(values.MailingProofRelationFile).map(
                                                    (x, index) => {

                                                      return (
                                                        <>
                                                          <div className="d-block d-sm-table">
                                                            <div className="Circularprogress yellow">
                                                              {" "}
                                                              <span className="Circularprogress-left">
                                                                {" "}
                                                                <span className="Circularprogress-bar"></span>{" "}
                                                              </span>{" "}
                                                              <span className="Circularprogress-right">
                                                                {" "}
                                                                <span className="Circularprogress-bar"></span>{" "}
                                                              </span>
                                                              <div className="Circularprogress-value t-pink fs12 fw-400">
                                                                {getSecondPart(
                                                                  values.MailingProofRelationFile[x].type
                                                                ).toUpperCase()}
                                                              </div>
                                                            </div>

                                                            <div className="fileName">
                                                              {/* <div className="position-absolute ml-55"> */}
                                                              <div >
                                                                <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                                                  {" "}
                                                                  {values.MailingProofRelationFile[x].name}
                                                                </p>
                                                                <div>
                                                                  <p className="m-0 t-grey-400 fw-400 fs14 ">
                                                                    {" "}
                                                                    {Math.round(
                                                                      values.MailingProofRelationFileSize / 1024
                                                                    )}{" "}
                                                                    kb /
                                                                    {Math.round(
                                                                      values.MailingProofRelationFileSize / 1024
                                                                    )}{" "}
                                                                    kb
                                                                  </p>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div className="my-3 cursor bg-Pink edge p-1">
                                                            {/* <img
                            src={Cross}
                            alt="cross"
                            className="mx-auto d-block "
                            onClick={() =>
                              handleDrctChange(
                                "PermanentProofRelationFile",
                                ""
                              )
                            }
                          /> */}

                                                            <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                                                              className="mx-auto d-block"
                                                              onClick={() =>
                                                                handleDrctChange(
                                                                  "MailingProofRelationFile",
                                                                  ""
                                                                )
                                                              }
                                                            />
                                                          </div>
                                                        </>
                                                      );
                                                    }
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  <input
                                                    type="file"
                                                    name="MailingProofRelationFile"

                                                    onChange={handleChange}
                                                    value={values.MailingProofRelationFile}
                                                    // onChange={(e) => onFileResize(e)}
                                                    className="custom-file-input lh0 "
                                                    accept="application/pdf ,.jpg, .jpeg, .png"
                                                    required={true}
                                                  />




                                                </>

                                              )}


                                            </>

                                          )}

                                          <div className="upload-cnic-hint mt8">
                                            The file uploaded must either be a PDF, PNG or JPEG file and  must be  5 MB or smaller
                                          </div>






                                        </div >



                                      </>



                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </div >
                              </div >
                            </div >

                            {/* new development for proof of address type end mailing */}

































































                          </>
                        ) : (
                          <></>
                        )}
                      </div >
                    </div >
                  </div >
                  <div className="row">
                    <div >
                      <hr className="t-grey-200 mt-40 mb-40"></hr>
                    </div>
                  </div>



                  <div className="row">
                    <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                      <label htmlFor="email" className="col-form-label fw-500">
                        Email Address
                      </label>
                      <div className="col-12 mt-auto">
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="joe@company.com"
                          onChange={handleChange}
                          value={signedEmail}
                          // value={values.email ? values?.email : signedEmail}
                          id="email"
                          required={true}
                          disabled

                          maxLength="50"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                      <label htmlFor="phone" className="col-form-label fw-500">
                        Phone Number
                      </label>
                      <div className="mt-auto">
                        <ReactPhoneInput
                          country={"pk"}

                          inputExtraProps={{
                            name: "Number",
                            required: true,
                            autoFocus: true,

                          }}

                          id="phone"
                          countryCodeEditable={false}

                          containerClass=""

                          // defaultCountry={"sg"}


                          value={values.Number}
                          // value={ 92 + values.Number.substr(1)}
                          onChange={(text) => handleDrctChange("Number", text)}
                          specialLabel={false}

                          inputClass="form-control p10"
                          disabled={values?.editFormStatus == "true"}
                        />
                        {(values.Number === "" || values.Number.length < 12) && <RequiredFeild />}
                        {!values?.Number && values.continues ? <span id="MailCountry" className="text-danger fs10" >Please provide Number</span> : ""}
                      </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                      <label
                        className="col-12 col-form-label  fw-500"
                      >
                        Phone Number Owned by
                        <Tooltip title="We're required to collect your phone number whether it belongs to you or someone else. It's
encouraged that you use a number registered in your name. Otherwise you'll need to provide
further information." placement="bottom"
                        >
                          <span className="ml10">
                            <HelpIcon />
                          </span>
                        </Tooltip>
                      </label>
                      <ul className="text-center combineButton RadioToButton px-0 d-flex justify-content-center mt-auto mb-0">
                        <li className="w-50 br-right">
                          <input
                            type="radio"
                            id="Owned"
                            name="CellPhone"
                            value="1"
                            defaultChecked={values.CellPhone == "1"}
                            onChange={handleChange}
                            required={true}
                            disabled={values?.editFormStatus == "true"}
                          />
                          <label htmlFor="Owned" className={`${values?.editFormStatus == "true" && 'li_disable'} btn-txt`}>
                            Me
                          </label>
                        </li>
                        <li className="w-50">
                          <input
                            type="radio"
                            id="Other"
                            name="CellPhone"
                            value="2"
                            defaultChecked={values.CellPhone == "2"}
                            onChange={handleChange}
                            required={true}
                            disabled={values?.editFormStatus == "true"}
                          />
                          <label htmlFor="Other" className={`${values?.editFormStatus == "true" && 'li_disable'} btn-txt`}>
                            Someone Else
                          </label>
                        </li>
                      </ul>
                      {!values.CellPhone && values.continues ? <span id="CellPhone" className="text-danger fs10" >Please fill Marital Status</span> : ""}

                    </div>

                    {
                      values.CellPhone == "2" ? (
                        <>
                          <div className="col-12 col-sm-6 col-lg-4 mb-3 d-flex flex-column mb-3">
                            <label
                              htmlFor="ProofRelation"
                              className="col-12 col-form-label fw-500"
                            >
                              Phone Number Owner
                            </label>

                            <div className="mt-auto">
                              {/* <Select
                              onChange={(e) =>
                                handleDrctChange("proofRelation", e)
                              }
                              placeholder="Select any one "
                              id="ProofRelation"
                              className="relative-dropdown"
                              options={RealitiveRelation}
                              defaultInputValue={values.proofRelation.label ? values.proofRelation.label : ''}
                            /> */}


                              <Select defaultValue={values.proofRelation.children ? values.proofRelation.children : undefined} placeholder="Select any one" onSelect={(value, event) => handleDrctChange("proofRelation", event)} rules={[{ required: true }]} disabled={values?.editFormStatus == "true"}>

                                {RealitiveRelation.map(realitiveRelation => (
                                  <Option key={realitiveRelation?.value}>{realitiveRelation.label}</Option>
                                ))}

                              </Select>



                            </div>
                            {!values?.proofRelation?.children && <RequiredFeild />}
                            {!values?.proofRelation?.children && values.continues ? <span id="proofRelation" className="text-danger fs10" >Please Select Relation</span> : ""}


                          </div>
                          <div className="col-12 col-sm-6 col-lg-4 mb-3 d-flex flex-column mb-1">
                            <label
                              htmlFor="ProofRelationName"
                              className="col-12 col-form-label fw-500"
                            >
                              Owner's Full Name
                            </label>
                            <input
                              type="text"
                              name="ProofRelationName"
                              className="form-control mt-auto"
                              placeholder="Muhammad Khan"
                              onChange={handleChange}
                              value={values.ProofRelationName ? values.ProofRelationName : ''}
                              id="ProofRelationName"
                              required={true}
                              maxLength="60"
                            />
                            {!values.ProofRelationName && values.continues ? <span className="text-danger fs10" >Please fill Realitive Name</span> : ""}

                          </div>

                          {values.proofRelation.children !== 'Company' &&
                            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                              <label
                                htmlFor="RelativeCNIC"
                                className="col-form-label fw-500"
                              >
                                Owner's CNIC
                              </label>
                              <input
                                type="text"
                                name="RelativeCNIC"
                                className="form-control mt-auto"
                                placeholder="44444-2223334-7"
                                value={values.RelativeCNIC ? values.RelativeCNIC : ''}
                                onChange={handleChange}
                                id="RelativeCNIC"

                                minLength="13"
                                maxLength="13"
                                required={true}
                                disabled={values?.editFormStatus == "true"}
                              />
                              {!values.RelativeCNIC && values.continues ? <span className="text-danger fs10" >Please fill Realitive CNIC</span> : ""}

                            </div>
                          }

                          <div className="col-12 row">
                            <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                              <label
                                htmlFor="ProofRelationFile"
                                className="col-form-label fw-500"
                              >
                                Proof of Relationship with Owner
                                <Tooltip overlayStyle={{ maxWidth: '509px' }} title="Please submit documentary evidence of your relationship with the phone number owner. In case the owner is your relative please submit their CNIC picture (front only). In case the owner is a company, please submit a statement mentioning that you use this number. The statement must be on a company letterhead." placement="bottom"
                                >
                                  <span className="ml10">
                                    <HelpIcon />
                                  </span>
                                </Tooltip>
                              </label>
                              {console.log('after ProofRelationFile in personal detail ===========>>', values.ProofRelationFile)}


                              {values?.ProofRelationFileName ? (
                                <>
                                  <div className="d-block d-sm-table">
                                    <div className="Circularprogress yellow">
                                      {" "}
                                      <span className="Circularprogress-left">
                                        {" "}
                                        <span className="Circularprogress-bar"></span>{" "}
                                      </span>{" "}
                                      <span className="Circularprogress-right">
                                        {" "}
                                        <span className="Circularprogress-bar"></span>{" "}
                                      </span>
                                      <div className="Circularprogress-value t-pink fs12 fw-400">
                                        {values?.ProofRelationFileName?.split(".").pop().toUpperCase()}
                                      </div>
                                    </div>

                                    <div className="fileName">
                                      <div>
                                        <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                          {" "}
                                          {values?.ProofRelationFileName}
                                        </p>

                                      </div>
                                    </div>
                                  </div>

                                  {/* <img
                                    src={Cross}
                                    alt="cross"
                                    className="mx-auto d-block"
                                    onClick={() =>
                                      handleDrctChange(
                                        "ProofRelationFileName",
                                        ""
                                      )
                                    }
                                  /> */}
                                  {values?.editFormStatus == 'true' ? (
                                    <div className="my-3 btn-disable edge p-1">
                                      <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                                        className="mx-auto d-block"

                                      />
                                    </div>
                                  ) : (
                                    <div className="my-3 bg-Pink cursor edge p-1">
                                      <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                                        className="mx-auto d-block"
                                        onClick={() =>
                                          handleDrctChange(
                                            "ProofRelationFileName",
                                            ""
                                          )
                                        }
                                      />
                                    </div>
                                  )}


                                </>
                              ) : (
                                <>
                                  {values.ProofRelationFile ? (
                                    <>
                                      {Object.keys(values.ProofRelationFile).map(
                                        (x, index) => {

                                          return (
                                            <>
                                              <div className="d-block d-sm-table">
                                                <div className="Circularprogress yellow">
                                                  {" "}
                                                  <span className="Circularprogress-left">
                                                    {" "}
                                                    <span className="Circularprogress-bar"></span>{" "}
                                                  </span>{" "}
                                                  <span className="Circularprogress-right">
                                                    {" "}
                                                    <span className="Circularprogress-bar"></span>{" "}
                                                  </span>
                                                  <div className="Circularprogress-value t-pink fs12 fw-400">
                                                    {getSecondPart(
                                                      values.ProofRelationFile[x].type
                                                    ).toUpperCase()}
                                                  </div>
                                                </div>

                                                <div className="fileName">
                                                  {/* <div className="position-absolute ml-55"> */}
                                                  <div >
                                                    <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                                      {" "}
                                                      {values.ProofRelationFile[x].name}
                                                    </p>
                                                    <div>
                                                      <p className="m-0 t-grey-400 fw-400 fs14 ">
                                                        {" "}
                                                        {Math.round(
                                                          values.ProofRelationFileSize / 1024
                                                        )}{" "}
                                                        kb /
                                                        {Math.round(
                                                          values.ProofRelationFileSize / 1024
                                                        )}{" "}
                                                        kb
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              {/* <img
                                                src={Cross}
                                                alt="cross"
                                                className="mx-auto d-block "
                                                onClick={() =>
                                                  handleDrctChange(
                                                    "ProofRelationFile",
                                                    ""
                                                  )
                                                }
                                              /> */}

                                              {values?.editFormStatus == 'true' ? (
                                                <div className="my-3 btn-disable edge p-1">
                                                  <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                                                    className="mx-auto d-block"

                                                  />
                                                </div>
                                              ) : (
                                                <div className="my-3 cursor bg-Pink edge p-1">
                                                  <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                                                    className="mx-auto d-block"
                                                    onClick={() =>
                                                      handleDrctChange(
                                                        "ProofRelationFile",
                                                        ""
                                                      )
                                                    }
                                                  />
                                                </div>
                                              )}


                                            </>
                                          );
                                        }
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      <input
                                        type="file"
                                        name="ProofRelationFile"

                                        onChange={handleChange}
                                        value={values.ProofRelationFile}
                                        // onChange={(e) => onFileResize(e)}
                                        className="custom-file-input "
                                        accept=".jpg, .jpeg, .png"
                                        required={true}
                                        disabled={values?.editFormStatus == "true"}
                                      />

                                    </>

                                  )}

                                </>
                              )}









                            </div >
                          </div>
                          <div className="upload-cnic-hint">
                            The file uploaded must either be a PNG or JPEG file and  must be  5 MB or smaller
                          </div>
                        </>
                      ) : (
                        <></>
                      )}




















                  </div >

                </div >

                {values?.addnominee == false ? (



                  <div className="nominee-wrapper mt" >
                    <div className="display-contents cursor" onClick={() => handleDrctChange("addnominee", true)}>
                      <AddIcon /> <span className="nominee-text Bold">Add a nominee (optional)</span>
                    </div >
                  </div >
                ) : (
                  <>
                    <div className="row w-100">

                      <hr className="t-grey-200 mt-40 mb-40"></hr>

                    </div>
                    <h3 >Nominee</h3>

                    <div className="row justify-content-between mt">






                      <div className="col-12 mb-3 col-sm-4 d-flex flex-column mb-3">
                        <label
                          htmlFor="Nominee Name"
                          className="col-12 col-form-label fw-500"
                        >
                          Nominee Name
                          <Tooltip title="Add the exact name as per ID." placement="bottom"
                          >
                            <span className="ml10">
                              <HelpIcon />
                            </span>


                          </Tooltip>
                        </label>
                        <div className="col-12 mt-auto">
                          <input
                            type="text"
                            name="NomineeName"
                            className="form-control"
                            placeholder="Sehrish"
                            value={values.NomineeName}
                            onChange={handleChange}
                            id="Nominee Name"
                            required={true}
                            maxLength="60"
                            title="Only Alphabets are allowed"
                          />

                          {!values.NomineeName && values.continues ? <span className="text-danger fs10" >Please fill Nominee Name</span> : ""}

                        </div >
                      </div >

                      <div className="col-12 col-sm-6 col-lg-4 mb-3 d-flex flex-column">
                        <label
                          htmlFor="NomineeRelation"
                          className="col-12 col-form-label fw-500"
                        >
                          Relationship with Nominee
                        </label>

                        <div className="mt-auto d-flex flex-column">

                          <Select defaultValue={values.NomineeRelation.children ? values.NomineeRelation.children : undefined} placeholder="Select any one" onSelect={(value, event) => handleDrctChange("NomineeRelation", event)} rules={[{ required: true }]}>

                            {NomineeRelations.map(nomineeRelation => (
                              <Option key={nomineeRelation?.value}>{nomineeRelation.label}</Option>
                            ))}

                          </Select>



                        </div >
                        {values.NomineeRelation == "" && <RequiredFeild />}
                        {!values.NomineeRelation && values.continues ? <span className="text-danger fs10" >Please select Relation with Nominee</span> : ""}


                      </div >

                      <div className="col-12 mb-3 col-sm-4 d-flex flex-column">
                        <label
                          htmlFor="NomineeIDType"
                          className="col-12 col-form-label fw-500"
                        >
                          ID Type
                        </label>

                        <div className="mt-auto">



                          <Select defaultValue={values?.NomineeIDType ? values?.NomineeIDType : undefined} placeholder="ID Type" onSelect={(value, event) => handleDrctChange("NomineeIDType", event.value)} rules={[{ required: true }]}>

                            {NomineeIDType.map(nomineeidType => (
                              <Option key={nomineeidType?.value}>{nomineeidType?.label}</Option>
                            ))}

                          </Select>

                        </div >
                        {values.NomineeIDType == "" && <RequiredFeild />}
                        {!values.NomineeIDType && values.continues ? <span className="text-danger fs10" >Please select Id Type</span> : ""}

                      </div >

                      <div className="col-12 mb-3 col-sm-4 d-flex flex-column">
                        <label
                          htmlFor="NomineeIDNumber"
                          className="col-12 col-form-label fw-500"
                        >
                          {/* CNIC */}
                          ID Number
                        </label>

                        <input
                          type="text"
                          name="NomineeIDNumber"
                          className="form-control mt-auto"
                          placeholder="44444-2223334-7"
                          value={values.NomineeIDNumber}
                          onChange={handleChange}
                          id="NomineeIDNumber"
                          minLength="13"
                          maxLength="13"
                          required
                        />
                        {!values.NomineeIDNumber && values.continues ? <span className="text-danger fs10" >Please select Id Number</span> : ""}
                      </div >



                      <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                        <label
                          htmlFor="issueDay"
                          className="col-12 col-form-label fw-500"
                        >
                          Issue Date (e.g. 28-02-1995)
                          <Tooltip overlayStyle={{ maxWidth: '280px' }} title="Only numbers and dashes are accepted." placement="bottom"
                          >
                            <span className="ml10">
                              <HelpIcon />
                            </span>
                          </Tooltip>
                        </label>

                        <DatePickerInput
                          onChange={(e) =>
                            onChangeDate(
                              e,
                              "NomineeIssueDate",
                              new Date("05/11/2019"),
                              new Date()
                            )
                          }
                          className="my-custom-datepicker-component mt-auto"
                          defaultValue={
                            values?.NomineeIssueDate?.includes("N") ? "" : values?.NomineeIssueDate
                          }
                          name="DatePicker"
                          placeholder="dd-mm-yyyy"
                          maxDate={new Date()}
                          startDate={new Date()}

                          maxLength="10"
                          showOnInputClick={true}
                          displayFormat="DD-MM-YYYY"
                          required
                        />
                        {values?.NomineeIssueDate === "" && <RequiredFeild />}
                        {!values.NomineeIssueDate && values.continues ? <span className="text-danger fs10" >Please select Issue Date</span> : ""}
                      </div >


                      {!values?.NomineeLifeTimeExpiry && (
                        <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">

                          {/* {values?.IssueDate && <> */}


                          <label
                            htmlFor="expiryDay"
                            className="col-12 col-form-label fw-500"
                          >
                            Expiry Date (e.g. 28-02-1995)
                            <Tooltip overlayStyle={{ maxWidth: '280px' }} title="Only numbers and dashes are accepted." placement="bottom"
                            >
                              <span className="ml10">
                                <HelpIcon />
                              </span>
                            </Tooltip>
                          </label>
                          <DatePickerInput
                            onChange={(e) =>
                              onChangeDate(
                                e,
                                "NomineeExpiryDate",
                                new Date("05-11-2019"),
                                new Date()
                              )
                            }
                            className="my-custom-datepicker-component mt-auto"
                            defaultValue={
                              values?.NomineeExpiryDate?.includes("N") ? "" : values?.NomineeExpiryDate
                            }
                            name="DatePicker"
                            placeholder="dd-mm-yyyy"
                            minDate={(values?.NomineeIssueDate?.includes("N") || values?.NomineeIssueDate == "") ? new Date() : new Date(values?.NomineeIssueDate)}
                            startDate={(values?.NomineeIssueDate?.includes("N") || values?.NomineeIssueDate == "") ? new Date() : new Date(values?.NomineeIssueDate)}
                            // readOnly
                            maxLength="10"
                            showOnInputClick={true}
                            displayFormat="DD-MM-YYYY"
                            required
                          />
                          {values.NomineeExpiryDate === "" && !values.NomineeLifeTimeExpiry && (
                            <RequiredFeild />
                          )}
                          {!values.NomineeExpiryDate && values.continues ? <span className="text-danger fs10" >Please select Expiry Date</span> : ""}


                          {/* </>} */}


                        </div >
                      )}



                      {/* {values?.IssueDate && <> */}

                      <div className="col-12 col-sm-6 my-auto col-lg-4 d-flex flex-column">
                        <label
                          htmlFor="NomineeLifeTimeExpiry"
                          className="col-12 pb-2 pt-0 col-form-label fw-500"
                        >
                          Expiry Limit
                        </label>
                        <div className="mt-auto">
                          <input
                            className="form-check-input me-2"
                            type="checkbox"
                            defaultChecked={values.NomineeLifeTimeExpiry}
                            onChange={handleChange}
                            name="NomineeLifeTimeExpiry"
                            id="NomineeLifeTimeExpiry"
                          />
                          <label
                            className="form-check-label lifetimeexpirylabel"
                            htmlFor="NomineeLifeTimeExpiry"
                          >
                            Life Time Expiry
                          </label>
                        </div>
                      </div>

                      {/* </>} */}








                    </div >





                    <div className="nominee-wrapper mt">
                      <div className="display-contents cursor" onClick={() => handleDrctChange('addnominee', false)}>
                        <RemoveIcon /> <span className="nominee-text Bold">Remove nominee </span>
                      </div>
                    </div>
                  </>

                )}
                <div className="row">
                  <div >
                    <hr className="t-grey-200 mt-40 mb-40"></hr>
                  </div>
                </div>

                <div className="mb-3 row">
                  <Disclaimer />
                  <div className="col-lg-5 col-xl-4 ">
                    <div className="text-end threeButton d-lg-flex justify-content-end">
                      <div className='px-2 d-lg-none mb-2'>
                        <button
                          className="btn-filled fs16 px-2 px-md-3 btnPad disableBtn naviBtn"
                          type="submit"
                          id='personalContinuee'
                          // onClick={SaveOnContinueSubmit}
                          disabled={backAndContinueBtnStatus == true}
                        >
                          {backAndContinueBtnStatus ? (

                            <div className="whitespinner">
                              <div className="bounce1"></div>
                              <div className="bounce2"></div>
                              <div className="bounce3"></div>
                            </div>
                          ) : (
                            <>Continue</>
                          )}
                        </button>
                      </div>
                      <div className="d-flex mb-2 mb-lg-0">
                        <div className='px-2'>
                          <button
                            className="btn-outlined fs16 disableBtn px-2 px-md-3 btnPad"
                            type="button"
                            // onClick={() => handleDrctChange('step', 1)}
                            disabled={backAndContinueBtnStatus == true}
                            onClick={() => handleBackBtn()}
                          >
                            Back
                          </button>
                        </div>
                        <div className='px-2'>
                          <button
                            className="btn-outlined  fs16 px-2 px-md-3 btnPad disableBtn"
                            type='button'
                            disabled={backAndContinueBtnStatus == true}
                            onClick={SaveSubmit}
                          >
                            {sendingSaveReq ? (
                              <div className="spinner">
                                <div className="bounce1"></div>
                                <div className="bounce2"></div>
                                <div className="bounce3"></div>
                              </div>
                            ) : (
                              <>Save & Exit</>
                            )}
                          </button>
                        </div>
                      </div>

                      <div className='px-2 d-none d-lg-block'>
                        <button
                          className="btn-filled fs16 px-2 px-md-3 disableBtn btnPad  naviBtn"
                          type="submit"
                          id='personalContinuee2'
                          disabled={backAndContinueBtnStatus == true}
                        // onClick={SaveOnContinueSubmit}
                        >
                          {backAndContinueBtnStatus ? (

                            <div className="whitespinner">
                              <div className="bounce1"></div>
                              <div className="bounce2"></div>
                              <div className="bounce3"></div>
                            </div>
                          ) : (
                            <>Continue</>
                          )}

                        </button>
                      </div>
                    </div>
                    {backAndContinueBtnStatus &&
                      <div className="text-end">

                        <p className="fw-400 fs14 t-grey-400 pt3">

                          Please wait while the documents upload

                        </p>
                      </div>
                    }

                    {errorMessage &&
                      <div className="text-end pt 3">

                        <p className="fw-400 fs14 t-red">

                          An unknown error has occurred

                        </p>
                      </div>

                    }
                  </div>


                  {/* <div className="col-lg-5 col-xl-4 text-end">
                  <button
                    className="btn-outlined fs16 px-2 px-md-3 py-01 py-md-2 mx-2 naviBtn"
                    type="button"
                    // onClick={() => handleDrctChange('step', 1)}
                    onClick={() => handleBackBtn()}
                  >
                    Back
                  </button>
                    <button
                      className="btn-outlined fs16 px-2 px-md-3 py-01 py-md-2 mx-2 naviBtn"
                      type='button'
                      onClick={SaveSubmit}
                    >
                      {sendingSaveReq ? (
                        // <div
                        //   className="spinner-border t-pink"
                        //   role="status"
                        // >
                        //   <span className="visually-hidden">Loading...</span>
                        // </div>
                        <div className="spinner">
                        <div className="bounce1"></div>
                        <div className="bounce2"></div>
                        <div className="bounce3"></div>
                      </div>
                      ) : (
                        <>Save & Exit</>
                      )}
                    </button>
                    <button
                      className="btn-filled fs16 px-2 px-md-3 py-01 py-md-2 mx-2 naviBtn"
                      type="submit"

                      onClick={SaveOnContinueSubmit}
                    >
                      Continue
                    </button>
                  </div> */}


                </div>
              </form >
              <p className="text-danger fs12 text-end">{error}</p>
            </div >
            <div
              className="modal"
              tabIndex="-1"
              role="dialog"
              id="SaveExitModal"
            >
              <div className="modal-dialog centerr" role="document">
                <div className="modal-content">
                  <div className="modal-header p-0">
                    <h5 className="modal-title t-pink">Information Submited</h5>

                    <span className="close cross">&times;</span>
                  </div>
                  <div className="modal-body px-0">
                    {" "}
                    <p className="fw-500 fs16 ms-auto t-grey-400 cursorPointer">
                      Thank You your information has been saved.
                    </p>
                  </div>
                  <div className="modal-footer px-0">
                    <NavLink to="/Dashboard">
                      <button
                        type="button"
                        className="btn-outlined fs16 px-3 py-2 mx-2 close"
                        data-dismiss="modal"
                      // onClick={() => logout()}
                      >
                        OK
                      </button>
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div >
        </div >
      </div >
    </>
  );
};

export default PersonalDetails;


const HelpIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 15C9.45 15 9 14.55 9 14V10C9 9.45 9.45 9 10 9C10.55 9 11 9.45 11 10V14C11 14.55 10.55 15 10 15ZM11 7H9V5H11V7Z" fill="#D2D6DC" />
  </svg>

)

const AddIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM15 11H11V15H9V11H5V9H9V5H11V9H15V11Z" fill="#E92A5E" />
  </svg>

)

const RemoveIcon = () => (
  <svg width="20" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 12C7 12.55 7.45 13 8 13H16C16.55 13 17 12.55 17 12C17 11.45 16.55 11 16 11H8C7.45 11 7 11.45 7 12ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#E92A5E" />
  </svg>

)
